/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexVersionOAuthSettingsFragmentDoc } from "../components/app/PublishedAppRunSettingsEditor.generated";
export type InputCellMpFragment = {
  readonly __typename: "Parameter";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly name: c.ParameterName;
  readonly outputType: Types.ParameterOutputType;
  readonly inputType: Types.ParameterInputType;
  readonly options: c.ParameterOptions | null;
  readonly defaultValueString: c.JsonSerializedParameterValueContents;
  readonly required: boolean;
  readonly inputCellId: c.ParameterId;
};

export type DisplayTableConfigFragment = {
  readonly __typename: "DisplayTableConfig";
  readonly id: c.DisplayTableConfigId;
  readonly revision: number;
  readonly pageSize: number;
  readonly height: number | null;
  readonly hideIcons: boolean;
  readonly defaultColumnWidth: number | null;
  readonly hideIndex: boolean;
  readonly sortByColumnDefault: string | null;
  readonly sortByIndexColumnDefault: number | null;
  readonly sortDirectionDefault: Types.SortDirection;
  readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
  readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
  readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
  readonly filters: c.TableFiltersDefinition | null;
  readonly calcs: c.CalcsDefinition | null;
  readonly pinnedColumns: ReadonlyArray<string> | null;
  readonly hiddenColumns: ReadonlyArray<string> | null;
  readonly pinIndexColumns: boolean;
  readonly showAggregations: boolean;
  readonly columnAggregations: c.ColumnAggregationsDefinition | null;
  readonly conditionalFormattingReferences: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly conditionalFormattingReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
  readonly columnProperties: ReadonlyArray<{
    readonly __typename: "ColumnProperties";
    readonly revision: number;
    readonly originalName: c.DisplayTableColumnId;
    readonly displayFormat: c.ColumnDisplayFormat | null;
    readonly renameTo: string | null;
    readonly size: number | null;
    readonly wrapText: boolean | null;
  }>;
  readonly filtersReferences: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly filtersReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type DisplayTableCellMpFragment = {
  readonly __typename: "DisplayTableCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataframe: c.NoCodeCellDataframe | null;
  readonly resultVariable: string;
  readonly displayTableCellId: c.DisplayTableCellId;
  readonly displayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  };
};

export type MarkdownCellMpFragment = {
  readonly __typename: "MarkdownCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly source: string;
  readonly markdownCellId: c.MarkdownCellId;
  readonly cellReferencesV2: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type MetricCellMpFragment = {
  readonly __typename: "MetricCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly title: string | null;
  readonly valueVariableName: string | null;
  readonly displayFormat: c.MetricDisplayFormat | null;
  readonly showComparison: boolean;
  readonly comparisonType: Types.MetricCellComparisonType | null;
  readonly comparisonVariableName: string | null;
  readonly comparisonAggregate: c.MetricCellAggregate | null;
  readonly comparisonFormat: Types.MetricCellComparisonFormat | null;
  readonly comparisonLabel: string | null;
  readonly valueColumn: string | null;
  readonly valueRowIndex: number | null;
  readonly valueAggregate: c.MetricCellAggregate | null;
  readonly comparisonColumn: string | null;
  readonly comparisonRowIndex: number | null;
  readonly outputResult: boolean;
  readonly valueResultVariable: string | null;
  readonly comparisonResultVariable: string | null;
  readonly metricCellId: c.MetricCellId;
  readonly cellReferencesV2: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CodeCellMpFragment = {
  readonly __typename: "CodeCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly source: string;
  readonly codeCellId: c.CodeCellId;
  readonly cellReferencesV2: {
    readonly __typename: "PythonCellReferencesV2";
    readonly imports: ReadonlyArray<c.VariableName>;
    readonly importStrings: ReadonlyArray<string>;
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly referencedKeys: ReadonlyArray<c.ParamReferenceKey> | null;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly functions: ReadonlyArray<{
      readonly __typename: "FunctionDefinition";
      readonly name: string;
      readonly src: string;
    }>;
    readonly errors: ReadonlyArray<{
      readonly __typename: "ErrorDefinition";
      readonly errorType: string;
      readonly description: string;
      readonly location: {
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      };
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type SqlCellMpFragment = {
  readonly __typename: "SqlCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly source: string;
  readonly resultVariable: string;
  readonly useRichDisplay: boolean;
  readonly enablePreview: boolean;
  readonly castDecimals: boolean;
  readonly useNativeDates: boolean;
  readonly loadIntoDataFrame: boolean;
  readonly dataFrameCell: boolean;
  readonly allowDuplicateColumns: boolean;
  readonly sqlCellOutputType: Types.CellOutputType;
  readonly sqlCellReferencesV3: c.StoredSqlReferencesV3 | null;
  readonly jinjaCellReferencesV3: c.StoredCellReferencesV3 | null;
  readonly jinjaSqlReferences: c.StoredJinjaSqlReferences | null;
  readonly connectionId: c.DataConnectionId | null;
  readonly sqlCellId: c.SqlCellId;
  readonly sqlDisplayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  } | null;
  readonly cellReferencesV2: {
    readonly __typename: "SqlCellReferencesV2";
    readonly containsBlocks: boolean;
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type VegaChartCellMpFragment = {
  readonly __typename: "VegaChartCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly vegaSpec: c.VegaLiteSpec | null;
  readonly metadata: c.VegaMetadata | null;
  readonly selectedLayerIndex: number;
  readonly height: number | null;
  readonly defaultInputTimezone: c.TimezoneName | null;
  readonly vegaChartCellId: c.VegaChartCellId;
};

export type TextCellMpFragment = {
  readonly __typename: "TextCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly richText: c.RichTextDocument;
  readonly textCellId: c.TextCellId;
  readonly cellReferencesV2: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type MapCellMpFragment = {
  readonly __typename: "MapCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly map: c.Map;
  readonly height: number | null;
  readonly mapCellId: c.MapCellId;
};

export type WritebackCellMpFragment = {
  readonly __typename: "WritebackCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly databaseName: string | null;
  readonly schemaName: string | null;
  readonly tableName: string | null;
  readonly dynamicTableName: boolean;
  readonly dataframeName: string | null;
  readonly runOnScheduledRun: boolean;
  readonly runInLogicView: boolean;
  readonly runInApp: boolean;
  readonly overwrite: boolean;
  readonly connectionId: c.DataConnectionId | null;
  readonly writebackCellId: c.WritebackCellId;
};

export type DbtMetricCellMpFragment = {
  readonly __typename: "DbtMetricCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly resultVariable: string;
  readonly useRichDisplay: boolean;
  readonly castDecimals: boolean;
  readonly useNativeDates: boolean;
  readonly selectedTimegrain: string | null;
  readonly startDate: c.DateTimeString | null;
  readonly endDate: c.DateTimeString | null;
  readonly selectedDimensions: ReadonlyArray<string> | null;
  readonly secondaryCalculations: ReadonlyArray<c.SecondaryCalculations>;
  readonly connectionId: c.DataConnectionId | null;
  readonly dbtMetricCellId: c.DbtMetricCellId;
  readonly metrics: ReadonlyArray<{
    readonly __typename: "DataSourceDbtMetric";
    readonly id: c.DataSourceDbtMetricId;
  }>;
  readonly dbtMetricDisplayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  } | null;
};

export type PivotCellMpFragment = {
  readonly __typename: "PivotCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataframe: c.NoCodeCellDataframe | null;
  readonly resultVariable: string;
  readonly pivotConfig: c.PivotTableConfig;
  readonly castDecimals: boolean;
  readonly pivotCellId: c.PivotCellId;
  readonly displayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  };
};

export type FilterCellMpFragment = {
  readonly __typename: "FilterCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataframe: c.NoCodeCellDataframe | null;
  readonly filters: c.FilterGroup | null;
  readonly resultVariable: string;
  readonly filterType: Types.FilterType;
  readonly appMode: Types.FilterCellAppMode;
  readonly castDecimals: boolean;
  readonly useQueryMode: boolean;
  readonly useNativeDates: boolean;
  readonly cellOutputType: Types.CellOutputType | null;
  readonly filterCellId: c.FilterCellId;
  readonly filtersReferences: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly filtersReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type ComponentImportCellMpFragment = {
  readonly __typename: "ComponentImportCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly childCellCount: number | null;
  readonly componentVersionId: c.HexVersionId | null;
  readonly componentImportCellId: c.ComponentImportCellId;
  readonly componentVersionStub: {
    readonly __typename: "ComponentVersionStub";
    readonly id: c.HexVersionId;
    readonly orgId: c.OrgId;
    readonly version: c.HexVersionString;
    readonly title: string;
    readonly componentId: c.HexId;
    readonly canView: boolean;
    readonly inTrash: boolean;
  } | null;
};

export type ChartCellMpFragment = {
  readonly __typename: "ChartCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly chartSpec: c.ChartSpec;
  readonly chartSelection: c.ChartSelection | null;
  readonly colorMappings: c.ChartColorMappings;
  readonly height: number | null;
  readonly resultVariable: string;
  readonly outputResult: boolean;
  readonly displayType: c.ChartDisplayType;
  readonly chartCellId: c.ChartCellId;
  readonly chartDisplayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  } | null;
};

export type BlockCellMpFragment = {
  readonly __typename: "BlockCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly blockConfig: c.BlockConfig | null;
  readonly blockCellId: c.BlockCellId;
};

export type ExploreCellMpFragment = {
  readonly __typename: "ExploreCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly colorMappings: c.ChartColorMappings;
  readonly spec: c.ExploreSpec;
  readonly semanticProjectId: c.SemanticProjectId | null;
  readonly resultVariables: ReadonlyArray<string>;
  readonly resultIncludeDetailColumns: boolean;
  readonly height: number | null;
  readonly exploreCellId: c.ExploreCellId;
  readonly exploreDataframe: c.ExploreCellDataframe | null;
  readonly displayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  };
};

export type CollapsibleCellMpFragment = {
  readonly __typename: "CollapsibleCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly labelStyle: Types.CollapsibleCellLabelStyle;
  readonly collapsibleCellId: c.CollapsibleCellId;
};

export type CellContentsMpFragment_BlockCell = {
  readonly __typename: "BlockCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly blockConfig: c.BlockConfig | null;
  readonly blockCellId: c.BlockCellId;
};

export type CellContentsMpFragment_CellGroupCell = {
  readonly __typename: "CellGroupCell";
};

export type CellContentsMpFragment_ChartCell = {
  readonly __typename: "ChartCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly chartSpec: c.ChartSpec;
  readonly chartSelection: c.ChartSelection | null;
  readonly colorMappings: c.ChartColorMappings;
  readonly height: number | null;
  readonly resultVariable: string;
  readonly outputResult: boolean;
  readonly displayType: c.ChartDisplayType;
  readonly chartCellId: c.ChartCellId;
  readonly chartDisplayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  } | null;
};

export type CellContentsMpFragment_CodeCell = {
  readonly __typename: "CodeCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly source: string;
  readonly codeCellId: c.CodeCellId;
  readonly cellReferencesV2: {
    readonly __typename: "PythonCellReferencesV2";
    readonly imports: ReadonlyArray<c.VariableName>;
    readonly importStrings: ReadonlyArray<string>;
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly referencedKeys: ReadonlyArray<c.ParamReferenceKey> | null;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly functions: ReadonlyArray<{
      readonly __typename: "FunctionDefinition";
      readonly name: string;
      readonly src: string;
    }>;
    readonly errors: ReadonlyArray<{
      readonly __typename: "ErrorDefinition";
      readonly errorType: string;
      readonly description: string;
      readonly location: {
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      };
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CellContentsMpFragment_CollapsibleCell = {
  readonly __typename: "CollapsibleCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly labelStyle: Types.CollapsibleCellLabelStyle;
  readonly collapsibleCellId: c.CollapsibleCellId;
};

export type CellContentsMpFragment_ComponentImportCell = {
  readonly __typename: "ComponentImportCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly childCellCount: number | null;
  readonly componentVersionId: c.HexVersionId | null;
  readonly componentImportCellId: c.ComponentImportCellId;
  readonly componentVersionStub: {
    readonly __typename: "ComponentVersionStub";
    readonly id: c.HexVersionId;
    readonly orgId: c.OrgId;
    readonly version: c.HexVersionString;
    readonly title: string;
    readonly componentId: c.HexId;
    readonly canView: boolean;
    readonly inTrash: boolean;
  } | null;
};

export type CellContentsMpFragment_DbtMetricCell = {
  readonly __typename: "DbtMetricCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly resultVariable: string;
  readonly useRichDisplay: boolean;
  readonly castDecimals: boolean;
  readonly useNativeDates: boolean;
  readonly selectedTimegrain: string | null;
  readonly startDate: c.DateTimeString | null;
  readonly endDate: c.DateTimeString | null;
  readonly selectedDimensions: ReadonlyArray<string> | null;
  readonly secondaryCalculations: ReadonlyArray<c.SecondaryCalculations>;
  readonly connectionId: c.DataConnectionId | null;
  readonly dbtMetricCellId: c.DbtMetricCellId;
  readonly metrics: ReadonlyArray<{
    readonly __typename: "DataSourceDbtMetric";
    readonly id: c.DataSourceDbtMetricId;
  }>;
  readonly dbtMetricDisplayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  } | null;
};

export type CellContentsMpFragment_DisplayTableCell = {
  readonly __typename: "DisplayTableCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataframe: c.NoCodeCellDataframe | null;
  readonly resultVariable: string;
  readonly displayTableCellId: c.DisplayTableCellId;
  readonly displayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  };
};

export type CellContentsMpFragment_ExploreCell = {
  readonly __typename: "ExploreCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly colorMappings: c.ChartColorMappings;
  readonly spec: c.ExploreSpec;
  readonly semanticProjectId: c.SemanticProjectId | null;
  readonly resultVariables: ReadonlyArray<string>;
  readonly resultIncludeDetailColumns: boolean;
  readonly height: number | null;
  readonly exploreCellId: c.ExploreCellId;
  readonly exploreDataframe: c.ExploreCellDataframe | null;
  readonly displayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  };
};

export type CellContentsMpFragment_FilterCell = {
  readonly __typename: "FilterCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataframe: c.NoCodeCellDataframe | null;
  readonly filters: c.FilterGroup | null;
  readonly resultVariable: string;
  readonly filterType: Types.FilterType;
  readonly appMode: Types.FilterCellAppMode;
  readonly castDecimals: boolean;
  readonly useQueryMode: boolean;
  readonly useNativeDates: boolean;
  readonly cellOutputType: Types.CellOutputType | null;
  readonly filterCellId: c.FilterCellId;
  readonly filtersReferences: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly filtersReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CellContentsMpFragment_MapCell = {
  readonly __typename: "MapCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly map: c.Map;
  readonly height: number | null;
  readonly mapCellId: c.MapCellId;
};

export type CellContentsMpFragment_MarkdownCell = {
  readonly __typename: "MarkdownCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly source: string;
  readonly markdownCellId: c.MarkdownCellId;
  readonly cellReferencesV2: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CellContentsMpFragment_MetricCell = {
  readonly __typename: "MetricCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly title: string | null;
  readonly valueVariableName: string | null;
  readonly displayFormat: c.MetricDisplayFormat | null;
  readonly showComparison: boolean;
  readonly comparisonType: Types.MetricCellComparisonType | null;
  readonly comparisonVariableName: string | null;
  readonly comparisonAggregate: c.MetricCellAggregate | null;
  readonly comparisonFormat: Types.MetricCellComparisonFormat | null;
  readonly comparisonLabel: string | null;
  readonly valueColumn: string | null;
  readonly valueRowIndex: number | null;
  readonly valueAggregate: c.MetricCellAggregate | null;
  readonly comparisonColumn: string | null;
  readonly comparisonRowIndex: number | null;
  readonly outputResult: boolean;
  readonly valueResultVariable: string | null;
  readonly comparisonResultVariable: string | null;
  readonly metricCellId: c.MetricCellId;
  readonly cellReferencesV2: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CellContentsMpFragment_Parameter = {
  readonly __typename: "Parameter";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly name: c.ParameterName;
  readonly outputType: Types.ParameterOutputType;
  readonly inputType: Types.ParameterInputType;
  readonly options: c.ParameterOptions | null;
  readonly defaultValueString: c.JsonSerializedParameterValueContents;
  readonly required: boolean;
  readonly inputCellId: c.ParameterId;
};

export type CellContentsMpFragment_PivotCell = {
  readonly __typename: "PivotCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataframe: c.NoCodeCellDataframe | null;
  readonly resultVariable: string;
  readonly pivotConfig: c.PivotTableConfig;
  readonly castDecimals: boolean;
  readonly pivotCellId: c.PivotCellId;
  readonly displayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  };
};

export type CellContentsMpFragment_SqlCell = {
  readonly __typename: "SqlCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly source: string;
  readonly resultVariable: string;
  readonly useRichDisplay: boolean;
  readonly enablePreview: boolean;
  readonly castDecimals: boolean;
  readonly useNativeDates: boolean;
  readonly loadIntoDataFrame: boolean;
  readonly dataFrameCell: boolean;
  readonly allowDuplicateColumns: boolean;
  readonly sqlCellOutputType: Types.CellOutputType;
  readonly sqlCellReferencesV3: c.StoredSqlReferencesV3 | null;
  readonly jinjaCellReferencesV3: c.StoredCellReferencesV3 | null;
  readonly jinjaSqlReferences: c.StoredJinjaSqlReferences | null;
  readonly connectionId: c.DataConnectionId | null;
  readonly sqlCellId: c.SqlCellId;
  readonly sqlDisplayTableConfig: {
    readonly __typename: "DisplayTableConfig";
    readonly id: c.DisplayTableConfigId;
    readonly revision: number;
    readonly pageSize: number;
    readonly height: number | null;
    readonly hideIcons: boolean;
    readonly defaultColumnWidth: number | null;
    readonly hideIndex: boolean;
    readonly sortByColumnDefault: string | null;
    readonly sortByIndexColumnDefault: number | null;
    readonly sortDirectionDefault: Types.SortDirection;
    readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
    readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
    readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
    readonly filters: c.TableFiltersDefinition | null;
    readonly calcs: c.CalcsDefinition | null;
    readonly pinnedColumns: ReadonlyArray<string> | null;
    readonly hiddenColumns: ReadonlyArray<string> | null;
    readonly pinIndexColumns: boolean;
    readonly showAggregations: boolean;
    readonly columnAggregations: c.ColumnAggregationsDefinition | null;
    readonly conditionalFormattingReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly conditionalFormattingReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
    readonly columnProperties: ReadonlyArray<{
      readonly __typename: "ColumnProperties";
      readonly revision: number;
      readonly originalName: c.DisplayTableColumnId;
      readonly displayFormat: c.ColumnDisplayFormat | null;
      readonly renameTo: string | null;
      readonly size: number | null;
      readonly wrapText: boolean | null;
    }>;
    readonly filtersReferences: {
      readonly __typename: "CellReferencesV2";
      readonly newParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
      readonly referencedParams: ReadonlyArray<{
        readonly __typename: "ParamReference";
        readonly param: c.VariableName;
        readonly locations: ReadonlyArray<{
          readonly __typename: "SourceLocation";
          readonly line: number;
          readonly column: number;
        }>;
      }>;
    } | null;
    readonly filtersReferencesParseError: {
      readonly __typename: "CellReferencesParseError";
      readonly error: string;
    } | null;
  } | null;
  readonly cellReferencesV2: {
    readonly __typename: "SqlCellReferencesV2";
    readonly containsBlocks: boolean;
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CellContentsMpFragment_TextCell = {
  readonly __typename: "TextCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly richText: c.RichTextDocument;
  readonly textCellId: c.TextCellId;
  readonly cellReferencesV2: {
    readonly __typename: "CellReferencesV2";
    readonly newParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
    readonly referencedParams: ReadonlyArray<{
      readonly __typename: "ParamReference";
      readonly param: c.VariableName;
      readonly locations: ReadonlyArray<{
        readonly __typename: "SourceLocation";
        readonly line: number;
        readonly column: number;
      }>;
    }>;
  } | null;
  readonly cellReferencesParseError: {
    readonly __typename: "CellReferencesParseError";
    readonly error: string;
  } | null;
};

export type CellContentsMpFragment_VegaChartCell = {
  readonly __typename: "VegaChartCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly vegaSpec: c.VegaLiteSpec | null;
  readonly metadata: c.VegaMetadata | null;
  readonly selectedLayerIndex: number;
  readonly height: number | null;
  readonly defaultInputTimezone: c.TimezoneName | null;
  readonly vegaChartCellId: c.VegaChartCellId;
};

export type CellContentsMpFragment_WritebackCell = {
  readonly __typename: "WritebackCell";
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly databaseName: string | null;
  readonly schemaName: string | null;
  readonly tableName: string | null;
  readonly dynamicTableName: boolean;
  readonly dataframeName: string | null;
  readonly runOnScheduledRun: boolean;
  readonly runInLogicView: boolean;
  readonly runInApp: boolean;
  readonly overwrite: boolean;
  readonly connectionId: c.DataConnectionId | null;
  readonly writebackCellId: c.WritebackCellId;
};

export type CellContentsMpFragment =
  | CellContentsMpFragment_BlockCell
  | CellContentsMpFragment_CellGroupCell
  | CellContentsMpFragment_ChartCell
  | CellContentsMpFragment_CodeCell
  | CellContentsMpFragment_CollapsibleCell
  | CellContentsMpFragment_ComponentImportCell
  | CellContentsMpFragment_DbtMetricCell
  | CellContentsMpFragment_DisplayTableCell
  | CellContentsMpFragment_ExploreCell
  | CellContentsMpFragment_FilterCell
  | CellContentsMpFragment_MapCell
  | CellContentsMpFragment_MarkdownCell
  | CellContentsMpFragment_MetricCell
  | CellContentsMpFragment_Parameter
  | CellContentsMpFragment_PivotCell
  | CellContentsMpFragment_SqlCell
  | CellContentsMpFragment_TextCell
  | CellContentsMpFragment_VegaChartCell
  | CellContentsMpFragment_WritebackCell;

export type MagicEventAndChildrenFragment = {
  readonly __typename: "MagicEvent";
  readonly id: c.MagicEventId;
  readonly cellId: c.CellId | null;
  readonly agentChatThreadId: c.AgentChatThreadId | null;
  readonly accepted: boolean | null;
  readonly createdDate: c.DateTimeString;
  readonly dataConnectionId: c.DataConnectionId | null;
  readonly eventSource: Types.MagicEventSource | null;
  readonly eventType: Types.MagicKeyword;
  readonly result: string | null;
  readonly status: Types.MagicEventStatus | null;
  readonly userProvidedPrompt: string | null;
  readonly richTextPrompt: c.RichTextDocument | null;
  readonly userId: c.UserId;
  readonly parentEventId: c.MagicEventId | null;
  readonly unsupportedResponse: boolean;
  readonly revision: number;
  readonly nextEventId: c.MagicEventId | null;
  readonly prevEventId: c.MagicEventId | null;
  readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
  readonly requestMode: Types.MagicRequestMode | null;
  readonly cellRunResult: Types.MagicCellRunResult | null;
  readonly userFacingResult: string | null;
  readonly acceptType: Types.MagicAcceptType | null;
  readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
  readonly failureReason: Types.MagicEventFailureReason | null;
  readonly autoTriggered: boolean | null;
  readonly duration: number | null;
  readonly timeToFirstToken: number | null;
  readonly cellPayload: c.MagicCellPayload | null;
  readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
  readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
  readonly summary: string | null;
  readonly cancelled: boolean;
  readonly intent: Types.ExploreIntent | null;
  readonly childEvents: ReadonlyArray<{
    readonly __typename: "MagicEvent";
    readonly id: c.MagicEventId;
    readonly cellId: c.CellId | null;
    readonly agentChatThreadId: c.AgentChatThreadId | null;
    readonly accepted: boolean | null;
    readonly createdDate: c.DateTimeString;
    readonly dataConnectionId: c.DataConnectionId | null;
    readonly eventSource: Types.MagicEventSource | null;
    readonly eventType: Types.MagicKeyword;
    readonly result: string | null;
    readonly status: Types.MagicEventStatus | null;
    readonly userProvidedPrompt: string | null;
    readonly richTextPrompt: c.RichTextDocument | null;
    readonly userId: c.UserId;
    readonly parentEventId: c.MagicEventId | null;
    readonly unsupportedResponse: boolean;
    readonly revision: number;
    readonly nextEventId: c.MagicEventId | null;
    readonly prevEventId: c.MagicEventId | null;
    readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
    readonly requestMode: Types.MagicRequestMode | null;
    readonly cellRunResult: Types.MagicCellRunResult | null;
    readonly userFacingResult: string | null;
    readonly acceptType: Types.MagicAcceptType | null;
    readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
    readonly failureReason: Types.MagicEventFailureReason | null;
    readonly autoTriggered: boolean | null;
    readonly duration: number | null;
    readonly timeToFirstToken: number | null;
    readonly cellPayload: c.MagicCellPayload | null;
    readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
    readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
    readonly summary: string | null;
    readonly cancelled: boolean;
    readonly intent: Types.ExploreIntent | null;
  }>;
};

export type MagicEventFragment = {
  readonly __typename: "MagicEvent";
  readonly id: c.MagicEventId;
  readonly cellId: c.CellId | null;
  readonly agentChatThreadId: c.AgentChatThreadId | null;
  readonly accepted: boolean | null;
  readonly createdDate: c.DateTimeString;
  readonly dataConnectionId: c.DataConnectionId | null;
  readonly eventSource: Types.MagicEventSource | null;
  readonly eventType: Types.MagicKeyword;
  readonly result: string | null;
  readonly status: Types.MagicEventStatus | null;
  readonly userProvidedPrompt: string | null;
  readonly richTextPrompt: c.RichTextDocument | null;
  readonly userId: c.UserId;
  readonly parentEventId: c.MagicEventId | null;
  readonly unsupportedResponse: boolean;
  readonly revision: number;
  readonly nextEventId: c.MagicEventId | null;
  readonly prevEventId: c.MagicEventId | null;
  readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
  readonly requestMode: Types.MagicRequestMode | null;
  readonly cellRunResult: Types.MagicCellRunResult | null;
  readonly userFacingResult: string | null;
  readonly acceptType: Types.MagicAcceptType | null;
  readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
  readonly failureReason: Types.MagicEventFailureReason | null;
  readonly autoTriggered: boolean | null;
  readonly duration: number | null;
  readonly timeToFirstToken: number | null;
  readonly cellPayload: c.MagicCellPayload | null;
  readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
  readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
  readonly summary: string | null;
  readonly cancelled: boolean;
  readonly intent: Types.ExploreIntent | null;
};

export type CellMpFragment = {
  readonly __typename: "Cell";
  readonly id: c.CellId;
  readonly staticId: c.StaticCellId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly order: string;
  readonly label: string | null;
  readonly sourceRevision: number;
  readonly cellType: Types.CellType;
  readonly parentComponentImportCellId: c.ComponentImportCellId | null;
  readonly staticCellIdInSourceComponent: c.StaticCellId | null;
  readonly componentImportCellId: c.ComponentImportCellId | null;
  readonly parentBlockCellId: c.BlockCellId | null;
  readonly blockCellId: c.BlockCellId | null;
  readonly latestMagicEventId: c.MagicEventId | null;
  readonly parentCellId: c.CellId | null;
  readonly cellContents:
    | {
        readonly __typename: "BlockCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly blockConfig: c.BlockConfig | null;
        readonly blockCellId: c.BlockCellId;
      }
    | { readonly __typename: "CellGroupCell" }
    | {
        readonly __typename: "ChartCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly chartSpec: c.ChartSpec;
        readonly chartSelection: c.ChartSelection | null;
        readonly colorMappings: c.ChartColorMappings;
        readonly height: number | null;
        readonly resultVariable: string;
        readonly outputResult: boolean;
        readonly displayType: c.ChartDisplayType;
        readonly chartCellId: c.ChartCellId;
        readonly chartDisplayTableConfig: {
          readonly __typename: "DisplayTableConfig";
          readonly id: c.DisplayTableConfigId;
          readonly revision: number;
          readonly pageSize: number;
          readonly height: number | null;
          readonly hideIcons: boolean;
          readonly defaultColumnWidth: number | null;
          readonly hideIndex: boolean;
          readonly sortByColumnDefault: string | null;
          readonly sortByIndexColumnDefault: number | null;
          readonly sortDirectionDefault: Types.SortDirection;
          readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
          readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
          readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
          readonly filters: c.TableFiltersDefinition | null;
          readonly calcs: c.CalcsDefinition | null;
          readonly pinnedColumns: ReadonlyArray<string> | null;
          readonly hiddenColumns: ReadonlyArray<string> | null;
          readonly pinIndexColumns: boolean;
          readonly showAggregations: boolean;
          readonly columnAggregations: c.ColumnAggregationsDefinition | null;
          readonly conditionalFormattingReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly conditionalFormattingReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
          readonly columnProperties: ReadonlyArray<{
            readonly __typename: "ColumnProperties";
            readonly revision: number;
            readonly originalName: c.DisplayTableColumnId;
            readonly displayFormat: c.ColumnDisplayFormat | null;
            readonly renameTo: string | null;
            readonly size: number | null;
            readonly wrapText: boolean | null;
          }>;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        } | null;
      }
    | {
        readonly __typename: "CodeCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly source: string;
        readonly codeCellId: c.CodeCellId;
        readonly cellReferencesV2: {
          readonly __typename: "PythonCellReferencesV2";
          readonly imports: ReadonlyArray<c.VariableName>;
          readonly importStrings: ReadonlyArray<string>;
          readonly newParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly referencedParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly referencedKeys: ReadonlyArray<c.ParamReferenceKey> | null;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly functions: ReadonlyArray<{
            readonly __typename: "FunctionDefinition";
            readonly name: string;
            readonly src: string;
          }>;
          readonly errors: ReadonlyArray<{
            readonly __typename: "ErrorDefinition";
            readonly errorType: string;
            readonly description: string;
            readonly location: {
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            };
          }>;
        } | null;
        readonly cellReferencesParseError: {
          readonly __typename: "CellReferencesParseError";
          readonly error: string;
        } | null;
      }
    | {
        readonly __typename: "CollapsibleCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly labelStyle: Types.CollapsibleCellLabelStyle;
        readonly collapsibleCellId: c.CollapsibleCellId;
      }
    | {
        readonly __typename: "ComponentImportCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly childCellCount: number | null;
        readonly componentVersionId: c.HexVersionId | null;
        readonly componentImportCellId: c.ComponentImportCellId;
        readonly componentVersionStub: {
          readonly __typename: "ComponentVersionStub";
          readonly id: c.HexVersionId;
          readonly orgId: c.OrgId;
          readonly version: c.HexVersionString;
          readonly title: string;
          readonly componentId: c.HexId;
          readonly canView: boolean;
          readonly inTrash: boolean;
        } | null;
      }
    | {
        readonly __typename: "DbtMetricCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly resultVariable: string;
        readonly useRichDisplay: boolean;
        readonly castDecimals: boolean;
        readonly useNativeDates: boolean;
        readonly selectedTimegrain: string | null;
        readonly startDate: c.DateTimeString | null;
        readonly endDate: c.DateTimeString | null;
        readonly selectedDimensions: ReadonlyArray<string> | null;
        readonly secondaryCalculations: ReadonlyArray<c.SecondaryCalculations>;
        readonly connectionId: c.DataConnectionId | null;
        readonly dbtMetricCellId: c.DbtMetricCellId;
        readonly metrics: ReadonlyArray<{
          readonly __typename: "DataSourceDbtMetric";
          readonly id: c.DataSourceDbtMetricId;
        }>;
        readonly dbtMetricDisplayTableConfig: {
          readonly __typename: "DisplayTableConfig";
          readonly id: c.DisplayTableConfigId;
          readonly revision: number;
          readonly pageSize: number;
          readonly height: number | null;
          readonly hideIcons: boolean;
          readonly defaultColumnWidth: number | null;
          readonly hideIndex: boolean;
          readonly sortByColumnDefault: string | null;
          readonly sortByIndexColumnDefault: number | null;
          readonly sortDirectionDefault: Types.SortDirection;
          readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
          readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
          readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
          readonly filters: c.TableFiltersDefinition | null;
          readonly calcs: c.CalcsDefinition | null;
          readonly pinnedColumns: ReadonlyArray<string> | null;
          readonly hiddenColumns: ReadonlyArray<string> | null;
          readonly pinIndexColumns: boolean;
          readonly showAggregations: boolean;
          readonly columnAggregations: c.ColumnAggregationsDefinition | null;
          readonly conditionalFormattingReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly conditionalFormattingReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
          readonly columnProperties: ReadonlyArray<{
            readonly __typename: "ColumnProperties";
            readonly revision: number;
            readonly originalName: c.DisplayTableColumnId;
            readonly displayFormat: c.ColumnDisplayFormat | null;
            readonly renameTo: string | null;
            readonly size: number | null;
            readonly wrapText: boolean | null;
          }>;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        } | null;
      }
    | {
        readonly __typename: "DisplayTableCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly dataframe: c.NoCodeCellDataframe | null;
        readonly resultVariable: string;
        readonly displayTableCellId: c.DisplayTableCellId;
        readonly displayTableConfig: {
          readonly __typename: "DisplayTableConfig";
          readonly id: c.DisplayTableConfigId;
          readonly revision: number;
          readonly pageSize: number;
          readonly height: number | null;
          readonly hideIcons: boolean;
          readonly defaultColumnWidth: number | null;
          readonly hideIndex: boolean;
          readonly sortByColumnDefault: string | null;
          readonly sortByIndexColumnDefault: number | null;
          readonly sortDirectionDefault: Types.SortDirection;
          readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
          readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
          readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
          readonly filters: c.TableFiltersDefinition | null;
          readonly calcs: c.CalcsDefinition | null;
          readonly pinnedColumns: ReadonlyArray<string> | null;
          readonly hiddenColumns: ReadonlyArray<string> | null;
          readonly pinIndexColumns: boolean;
          readonly showAggregations: boolean;
          readonly columnAggregations: c.ColumnAggregationsDefinition | null;
          readonly conditionalFormattingReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly conditionalFormattingReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
          readonly columnProperties: ReadonlyArray<{
            readonly __typename: "ColumnProperties";
            readonly revision: number;
            readonly originalName: c.DisplayTableColumnId;
            readonly displayFormat: c.ColumnDisplayFormat | null;
            readonly renameTo: string | null;
            readonly size: number | null;
            readonly wrapText: boolean | null;
          }>;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        };
      }
    | {
        readonly __typename: "ExploreCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly colorMappings: c.ChartColorMappings;
        readonly spec: c.ExploreSpec;
        readonly semanticProjectId: c.SemanticProjectId | null;
        readonly resultVariables: ReadonlyArray<string>;
        readonly resultIncludeDetailColumns: boolean;
        readonly height: number | null;
        readonly exploreCellId: c.ExploreCellId;
        readonly exploreDataframe: c.ExploreCellDataframe | null;
        readonly displayTableConfig: {
          readonly __typename: "DisplayTableConfig";
          readonly id: c.DisplayTableConfigId;
          readonly revision: number;
          readonly pageSize: number;
          readonly height: number | null;
          readonly hideIcons: boolean;
          readonly defaultColumnWidth: number | null;
          readonly hideIndex: boolean;
          readonly sortByColumnDefault: string | null;
          readonly sortByIndexColumnDefault: number | null;
          readonly sortDirectionDefault: Types.SortDirection;
          readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
          readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
          readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
          readonly filters: c.TableFiltersDefinition | null;
          readonly calcs: c.CalcsDefinition | null;
          readonly pinnedColumns: ReadonlyArray<string> | null;
          readonly hiddenColumns: ReadonlyArray<string> | null;
          readonly pinIndexColumns: boolean;
          readonly showAggregations: boolean;
          readonly columnAggregations: c.ColumnAggregationsDefinition | null;
          readonly conditionalFormattingReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly conditionalFormattingReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
          readonly columnProperties: ReadonlyArray<{
            readonly __typename: "ColumnProperties";
            readonly revision: number;
            readonly originalName: c.DisplayTableColumnId;
            readonly displayFormat: c.ColumnDisplayFormat | null;
            readonly renameTo: string | null;
            readonly size: number | null;
            readonly wrapText: boolean | null;
          }>;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        };
      }
    | {
        readonly __typename: "FilterCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly dataframe: c.NoCodeCellDataframe | null;
        readonly filters: c.FilterGroup | null;
        readonly resultVariable: string;
        readonly filterType: Types.FilterType;
        readonly appMode: Types.FilterCellAppMode;
        readonly castDecimals: boolean;
        readonly useQueryMode: boolean;
        readonly useNativeDates: boolean;
        readonly cellOutputType: Types.CellOutputType | null;
        readonly filterCellId: c.FilterCellId;
        readonly filtersReferences: {
          readonly __typename: "CellReferencesV2";
          readonly newParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly referencedParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
        } | null;
        readonly filtersReferencesParseError: {
          readonly __typename: "CellReferencesParseError";
          readonly error: string;
        } | null;
      }
    | {
        readonly __typename: "MapCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly map: c.Map;
        readonly height: number | null;
        readonly mapCellId: c.MapCellId;
      }
    | {
        readonly __typename: "MarkdownCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly source: string;
        readonly markdownCellId: c.MarkdownCellId;
        readonly cellReferencesV2: {
          readonly __typename: "CellReferencesV2";
          readonly newParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly referencedParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
        } | null;
        readonly cellReferencesParseError: {
          readonly __typename: "CellReferencesParseError";
          readonly error: string;
        } | null;
      }
    | {
        readonly __typename: "MetricCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly title: string | null;
        readonly valueVariableName: string | null;
        readonly displayFormat: c.MetricDisplayFormat | null;
        readonly showComparison: boolean;
        readonly comparisonType: Types.MetricCellComparisonType | null;
        readonly comparisonVariableName: string | null;
        readonly comparisonAggregate: c.MetricCellAggregate | null;
        readonly comparisonFormat: Types.MetricCellComparisonFormat | null;
        readonly comparisonLabel: string | null;
        readonly valueColumn: string | null;
        readonly valueRowIndex: number | null;
        readonly valueAggregate: c.MetricCellAggregate | null;
        readonly comparisonColumn: string | null;
        readonly comparisonRowIndex: number | null;
        readonly outputResult: boolean;
        readonly valueResultVariable: string | null;
        readonly comparisonResultVariable: string | null;
        readonly metricCellId: c.MetricCellId;
        readonly cellReferencesV2: {
          readonly __typename: "CellReferencesV2";
          readonly newParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly referencedParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
        } | null;
        readonly cellReferencesParseError: {
          readonly __typename: "CellReferencesParseError";
          readonly error: string;
        } | null;
      }
    | {
        readonly __typename: "Parameter";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly name: c.ParameterName;
        readonly outputType: Types.ParameterOutputType;
        readonly inputType: Types.ParameterInputType;
        readonly options: c.ParameterOptions | null;
        readonly defaultValueString: c.JsonSerializedParameterValueContents;
        readonly required: boolean;
        readonly inputCellId: c.ParameterId;
      }
    | {
        readonly __typename: "PivotCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly dataframe: c.NoCodeCellDataframe | null;
        readonly resultVariable: string;
        readonly pivotConfig: c.PivotTableConfig;
        readonly castDecimals: boolean;
        readonly pivotCellId: c.PivotCellId;
        readonly displayTableConfig: {
          readonly __typename: "DisplayTableConfig";
          readonly id: c.DisplayTableConfigId;
          readonly revision: number;
          readonly pageSize: number;
          readonly height: number | null;
          readonly hideIcons: boolean;
          readonly defaultColumnWidth: number | null;
          readonly hideIndex: boolean;
          readonly sortByColumnDefault: string | null;
          readonly sortByIndexColumnDefault: number | null;
          readonly sortDirectionDefault: Types.SortDirection;
          readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
          readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
          readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
          readonly filters: c.TableFiltersDefinition | null;
          readonly calcs: c.CalcsDefinition | null;
          readonly pinnedColumns: ReadonlyArray<string> | null;
          readonly hiddenColumns: ReadonlyArray<string> | null;
          readonly pinIndexColumns: boolean;
          readonly showAggregations: boolean;
          readonly columnAggregations: c.ColumnAggregationsDefinition | null;
          readonly conditionalFormattingReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly conditionalFormattingReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
          readonly columnProperties: ReadonlyArray<{
            readonly __typename: "ColumnProperties";
            readonly revision: number;
            readonly originalName: c.DisplayTableColumnId;
            readonly displayFormat: c.ColumnDisplayFormat | null;
            readonly renameTo: string | null;
            readonly size: number | null;
            readonly wrapText: boolean | null;
          }>;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        };
      }
    | {
        readonly __typename: "SqlCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly source: string;
        readonly resultVariable: string;
        readonly useRichDisplay: boolean;
        readonly enablePreview: boolean;
        readonly castDecimals: boolean;
        readonly useNativeDates: boolean;
        readonly loadIntoDataFrame: boolean;
        readonly dataFrameCell: boolean;
        readonly allowDuplicateColumns: boolean;
        readonly sqlCellOutputType: Types.CellOutputType;
        readonly sqlCellReferencesV3: c.StoredSqlReferencesV3 | null;
        readonly jinjaCellReferencesV3: c.StoredCellReferencesV3 | null;
        readonly jinjaSqlReferences: c.StoredJinjaSqlReferences | null;
        readonly connectionId: c.DataConnectionId | null;
        readonly sqlCellId: c.SqlCellId;
        readonly sqlDisplayTableConfig: {
          readonly __typename: "DisplayTableConfig";
          readonly id: c.DisplayTableConfigId;
          readonly revision: number;
          readonly pageSize: number;
          readonly height: number | null;
          readonly hideIcons: boolean;
          readonly defaultColumnWidth: number | null;
          readonly hideIndex: boolean;
          readonly sortByColumnDefault: string | null;
          readonly sortByIndexColumnDefault: number | null;
          readonly sortDirectionDefault: Types.SortDirection;
          readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
          readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
          readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
          readonly filters: c.TableFiltersDefinition | null;
          readonly calcs: c.CalcsDefinition | null;
          readonly pinnedColumns: ReadonlyArray<string> | null;
          readonly hiddenColumns: ReadonlyArray<string> | null;
          readonly pinIndexColumns: boolean;
          readonly showAggregations: boolean;
          readonly columnAggregations: c.ColumnAggregationsDefinition | null;
          readonly conditionalFormattingReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly conditionalFormattingReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
          readonly columnProperties: ReadonlyArray<{
            readonly __typename: "ColumnProperties";
            readonly revision: number;
            readonly originalName: c.DisplayTableColumnId;
            readonly displayFormat: c.ColumnDisplayFormat | null;
            readonly renameTo: string | null;
            readonly size: number | null;
            readonly wrapText: boolean | null;
          }>;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        } | null;
        readonly cellReferencesV2: {
          readonly __typename: "SqlCellReferencesV2";
          readonly containsBlocks: boolean;
          readonly newParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly referencedParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
        } | null;
        readonly cellReferencesParseError: {
          readonly __typename: "CellReferencesParseError";
          readonly error: string;
        } | null;
      }
    | {
        readonly __typename: "TextCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly richText: c.RichTextDocument;
        readonly textCellId: c.TextCellId;
        readonly cellReferencesV2: {
          readonly __typename: "CellReferencesV2";
          readonly newParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
          readonly referencedParams: ReadonlyArray<{
            readonly __typename: "ParamReference";
            readonly param: c.VariableName;
            readonly locations: ReadonlyArray<{
              readonly __typename: "SourceLocation";
              readonly line: number;
              readonly column: number;
            }>;
          }>;
        } | null;
        readonly cellReferencesParseError: {
          readonly __typename: "CellReferencesParseError";
          readonly error: string;
        } | null;
      }
    | {
        readonly __typename: "VegaChartCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly vegaSpec: c.VegaLiteSpec | null;
        readonly metadata: c.VegaMetadata | null;
        readonly selectedLayerIndex: number;
        readonly height: number | null;
        readonly defaultInputTimezone: c.TimezoneName | null;
        readonly vegaChartCellId: c.VegaChartCellId;
      }
    | {
        readonly __typename: "WritebackCell";
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly databaseName: string | null;
        readonly schemaName: string | null;
        readonly tableName: string | null;
        readonly dynamicTableName: boolean;
        readonly dataframeName: string | null;
        readonly runOnScheduledRun: boolean;
        readonly runInLogicView: boolean;
        readonly runInApp: boolean;
        readonly overwrite: boolean;
        readonly connectionId: c.DataConnectionId | null;
        readonly writebackCellId: c.WritebackCellId;
      };
  readonly latestMagicEvent: {
    readonly __typename: "MagicEvent";
    readonly id: c.MagicEventId;
    readonly cellId: c.CellId | null;
    readonly agentChatThreadId: c.AgentChatThreadId | null;
    readonly accepted: boolean | null;
    readonly createdDate: c.DateTimeString;
    readonly dataConnectionId: c.DataConnectionId | null;
    readonly eventSource: Types.MagicEventSource | null;
    readonly eventType: Types.MagicKeyword;
    readonly result: string | null;
    readonly status: Types.MagicEventStatus | null;
    readonly userProvidedPrompt: string | null;
    readonly richTextPrompt: c.RichTextDocument | null;
    readonly userId: c.UserId;
    readonly parentEventId: c.MagicEventId | null;
    readonly unsupportedResponse: boolean;
    readonly revision: number;
    readonly nextEventId: c.MagicEventId | null;
    readonly prevEventId: c.MagicEventId | null;
    readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
    readonly requestMode: Types.MagicRequestMode | null;
    readonly cellRunResult: Types.MagicCellRunResult | null;
    readonly userFacingResult: string | null;
    readonly acceptType: Types.MagicAcceptType | null;
    readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
    readonly failureReason: Types.MagicEventFailureReason | null;
    readonly autoTriggered: boolean | null;
    readonly duration: number | null;
    readonly timeToFirstToken: number | null;
    readonly cellPayload: c.MagicCellPayload | null;
    readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
    readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
    readonly summary: string | null;
    readonly cancelled: boolean;
    readonly intent: Types.ExploreIntent | null;
    readonly childEvents: ReadonlyArray<{
      readonly __typename: "MagicEvent";
      readonly id: c.MagicEventId;
      readonly cellId: c.CellId | null;
      readonly agentChatThreadId: c.AgentChatThreadId | null;
      readonly accepted: boolean | null;
      readonly createdDate: c.DateTimeString;
      readonly dataConnectionId: c.DataConnectionId | null;
      readonly eventSource: Types.MagicEventSource | null;
      readonly eventType: Types.MagicKeyword;
      readonly result: string | null;
      readonly status: Types.MagicEventStatus | null;
      readonly userProvidedPrompt: string | null;
      readonly richTextPrompt: c.RichTextDocument | null;
      readonly userId: c.UserId;
      readonly parentEventId: c.MagicEventId | null;
      readonly unsupportedResponse: boolean;
      readonly revision: number;
      readonly nextEventId: c.MagicEventId | null;
      readonly prevEventId: c.MagicEventId | null;
      readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
      readonly requestMode: Types.MagicRequestMode | null;
      readonly cellRunResult: Types.MagicCellRunResult | null;
      readonly userFacingResult: string | null;
      readonly acceptType: Types.MagicAcceptType | null;
      readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
      readonly failureReason: Types.MagicEventFailureReason | null;
      readonly autoTriggered: boolean | null;
      readonly duration: number | null;
      readonly timeToFirstToken: number | null;
      readonly cellPayload: c.MagicCellPayload | null;
      readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
      readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
      readonly summary: string | null;
      readonly cancelled: boolean;
      readonly intent: Types.ExploreIntent | null;
    }>;
  } | null;
};

export type FileMpFragment = {
  readonly __typename: "File";
  readonly id: c.FileId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly filename: string;
  readonly size: string;
  readonly uploadState: Types.FileUploadState;
  readonly inputCellId: c.ParameterId | null;
};

export type SecretMpFragment = {
  readonly __typename: "Secret";
  readonly id: c.SecretId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly name: c.SecretName;
};

export type HexVersionSecretMpFragment = {
  readonly __typename: "HexVersionSecret";
  readonly id: c.HexVersionSecretId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly secretId: c.SecretId;
};

export type DataConnectionHexVersionLinkMpFragment = {
  readonly __typename: "DataConnectionHexVersionLink";
  readonly id: c.DataConnectionHexVersionLinkId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly dataConnectionId: c.DataConnectionId;
  readonly dataConnectionLinkType: Types.DataConnectionLinkType;
};

export type ExternalFileIntegrationHexVersionLinkMpFragment = {
  readonly __typename: "ExternalFileIntegrationHexVersionLink";
  readonly id: c.ExternalFileIntegrationHexVersionLinkId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly externalFileIntegrationId: c.ExternalFileIntegrationId;
  readonly files: ReadonlyArray<string> | null;
};

export type FileHexVersionLinkMpFragment = {
  readonly __typename: "FileHexVersionLink";
  readonly id: c.FileHexVersionLinkId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly fileId: c.FileId;
};

export type VcsPackageHexVersionLinkMpFragment = {
  readonly __typename: "VcsPackageHexVersionLink";
  readonly id: c.VcsPackageHexVersionLinkId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly vcsPackageId: c.VcsPackageId;
};

export type SyncRepositoryHexVersionLinkMpFragment = {
  readonly __typename: "SyncRepositoryHexVersionLink";
  readonly id: c.SyncRepositoryHexVersionLinkId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly syncRepositoryId: c.SyncRepositoryId;
  readonly filePath: string | null;
  readonly branch: string;
};

export type SharedFilterMpFragment = {
  readonly __typename: "SharedFilter";
  readonly id: c.SharedFilterId;
  readonly name: string;
  readonly type: Types.SharedFilterInputType;
  readonly operator: Types.SharedFilterPredicateOp | null;
  readonly options: c.ParameterOptions | null;
  readonly autoLinks: c.SharedFilterAutoLinks;
  readonly manualLinks: c.SharedFilterManualLinks;
  readonly defaultValue: c.JsonSerializedParameterValueContents | null;
  readonly revision: number;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
};

export type CanvasElementMpFragment = {
  readonly __typename: "CanvasElement";
  readonly id: c.CanvasElementId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly width: number;
  readonly height: number;
  readonly x: number;
  readonly y: number;
  readonly z: number;
  readonly showLabel: boolean;
  readonly cellId: c.CellId;
};

export type CanvasLayoutMpFragment = {
  readonly __typename: "CanvasLayout";
  readonly id: c.CanvasLayoutId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly name: string | null;
  readonly height: number;
  readonly width: number;
  readonly canvasElements: ReadonlyArray<{
    readonly __typename: "CanvasElement";
    readonly id: c.CanvasElementId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly width: number;
    readonly height: number;
    readonly x: number;
    readonly y: number;
    readonly z: number;
    readonly showLabel: boolean;
    readonly cellId: c.CellId;
  }>;
};

export type GridElementMpFragment = {
  readonly __typename: "GridElement";
  readonly id: c.GridElementId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly height: number | null;
  readonly explorable: boolean | null;
  readonly showLabel: boolean;
  readonly showSource: boolean;
  readonly hideOutput: boolean;
  readonly type: Types.GridElementType;
  readonly entityId: c.GridElementEntityId;
};

export type GridColumnMpFragment = {
  readonly __typename: "GridColumn";
  readonly id: c.GridColumnId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly start: number;
  readonly end: number;
  readonly gridElements: ReadonlyArray<{
    readonly __typename: "GridElement";
    readonly id: c.GridElementId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly height: number | null;
    readonly explorable: boolean | null;
    readonly showLabel: boolean;
    readonly showSource: boolean;
    readonly hideOutput: boolean;
    readonly type: Types.GridElementType;
    readonly entityId: c.GridElementEntityId;
  }>;
};

export type GridRowMpFragment = {
  readonly __typename: "GridRow";
  readonly id: c.GridRowId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly order: string;
  readonly gridLayoutId: c.GridLayoutId;
  readonly gridColumns: ReadonlyArray<{
    readonly __typename: "GridColumn";
    readonly id: c.GridColumnId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly start: number;
    readonly end: number;
    readonly gridElements: ReadonlyArray<{
      readonly __typename: "GridElement";
      readonly id: c.GridElementId;
      readonly createdDate: c.DateTimeString;
      readonly updatedDate: c.DateTimeString;
      readonly deletedDate: c.DateTimeString | null;
      readonly revision: number;
      readonly height: number | null;
      readonly explorable: boolean | null;
      readonly showLabel: boolean;
      readonly showSource: boolean;
      readonly hideOutput: boolean;
      readonly type: Types.GridElementType;
      readonly entityId: c.GridElementEntityId;
    }>;
  }>;
};

export type GridLayoutMpFragment = {
  readonly __typename: "GridLayout";
  readonly id: c.GridLayoutId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly order: string;
  readonly name: string;
  readonly staticId: c.StaticGridLayoutId | null;
  readonly gridRows: ReadonlyArray<{
    readonly __typename: "GridRow";
    readonly id: c.GridRowId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly order: string;
    readonly gridLayoutId: c.GridLayoutId;
    readonly gridColumns: ReadonlyArray<{
      readonly __typename: "GridColumn";
      readonly id: c.GridColumnId;
      readonly createdDate: c.DateTimeString;
      readonly updatedDate: c.DateTimeString;
      readonly deletedDate: c.DateTimeString | null;
      readonly revision: number;
      readonly start: number;
      readonly end: number;
      readonly gridElements: ReadonlyArray<{
        readonly __typename: "GridElement";
        readonly id: c.GridElementId;
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly height: number | null;
        readonly explorable: boolean | null;
        readonly showLabel: boolean;
        readonly showSource: boolean;
        readonly hideOutput: boolean;
        readonly type: Types.GridElementType;
        readonly entityId: c.GridElementEntityId;
      }>;
    }>;
  }>;
};

export type StoryElementMpFragment = {
  readonly __typename: "StoryElement";
  readonly id: c.StoryElementId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly visible: boolean;
  readonly showLabel: boolean;
  readonly cell: { readonly __typename: "Cell"; readonly id: c.CellId } | null;
};

export type StoryLayoutMpFragment = {
  readonly __typename: "StoryLayout";
  readonly id: c.StoryLayoutId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly storyElements: ReadonlyArray<{
    readonly __typename: "StoryElement";
    readonly id: c.StoryElementId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly visible: boolean;
    readonly showLabel: boolean;
    readonly cell: {
      readonly __typename: "Cell";
      readonly id: c.CellId;
    } | null;
  }>;
};

export type ExploreMpFragment = {
  readonly __typename: "Explore";
  readonly id: c.ExploreId;
  readonly primaryCellStaticId: c.StaticCellId;
  readonly exploreFromCellStaticId: c.StaticCellId | null;
  readonly saved: boolean;
  readonly revision: number;
  readonly isSourceHexDeleted: boolean;
  readonly isSourceCellDeleted: boolean;
  readonly exploredFromCell: {
    readonly __typename: "Cell";
    readonly id: c.CellId;
    readonly label: string | null;
  } | null;
  readonly sourceHexVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly title: string;
      readonly archivedDate: c.DateTimeString | null;
      readonly trashDate: c.DateTimeString | null;
      readonly hexType: Types.HexType;
    };
  } | null;
};

export type HexVersionMpFragment = {
  readonly __typename: "HexVersion";
  readonly id: c.HexVersionId;
  readonly createdDate: c.DateTimeString;
  readonly updatedDate: c.DateTimeString;
  readonly deletedDate: c.DateTimeString | null;
  readonly revision: number;
  readonly date: c.DateTimeString;
  readonly name: string | null;
  readonly displayName: string | null;
  readonly importPreview: boolean;
  readonly preview: boolean;
  readonly description: string | null;
  readonly version: c.HexVersionString;
  readonly published: boolean;
  readonly layoutType: Types.LayoutType | null;
  readonly castDecimalsDefault: boolean;
  readonly prerunApp: boolean;
  readonly logicSessionId: c.AppSessionId;
  readonly defaultAppSessionId: c.AppSessionId | null;
  readonly appTheme: Types.AppTheme;
  readonly customPublishedAppThemeId: c.OrgPublishedAppThemeId | null;
  readonly graphV3: boolean;
  readonly kernelSize: c.KernelSize;
  readonly kernelImage: c.KernelImage;
  readonly kernelLogicIdleTimeoutMs: c.KernelIdleTimeout;
  readonly timezone: c.TimezoneName | null;
  readonly visibleMetadataFields: ReadonlyArray<Types.AppMetadataField>;
  readonly gridAppMaxWidth: number | null;
  readonly publishedSnapshotId: c.AppSessionId | null;
  readonly allowExecutionReordering: boolean;
  readonly canEdit: boolean;
  readonly editorUserAttributesOverride: c.UserAttributes | null;
  readonly referencedUserAttributes: c.ReferencedHexUserAttributes | null;
  readonly minervaDisabledAtEpoch: number | null;
  readonly semanticProjectMapping: c.SemanticProjectMapping | null;
  readonly agentChatThreadId: c.AgentChatThreadId | null;
  readonly activeColorPalette: {
    readonly __typename: "ColorPalette";
    readonly id: c.ColorPaletteId;
    readonly name: string;
    readonly colors: ReadonlyArray<c.Color>;
  } | null;
  readonly cells: ReadonlyArray<{
    readonly __typename: "Cell";
    readonly id: c.CellId;
    readonly staticId: c.StaticCellId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly order: string;
    readonly label: string | null;
    readonly sourceRevision: number;
    readonly cellType: Types.CellType;
    readonly parentComponentImportCellId: c.ComponentImportCellId | null;
    readonly staticCellIdInSourceComponent: c.StaticCellId | null;
    readonly componentImportCellId: c.ComponentImportCellId | null;
    readonly parentBlockCellId: c.BlockCellId | null;
    readonly blockCellId: c.BlockCellId | null;
    readonly latestMagicEventId: c.MagicEventId | null;
    readonly parentCellId: c.CellId | null;
    readonly cellContents:
      | {
          readonly __typename: "BlockCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly blockConfig: c.BlockConfig | null;
          readonly blockCellId: c.BlockCellId;
        }
      | { readonly __typename: "CellGroupCell" }
      | {
          readonly __typename: "ChartCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly chartSpec: c.ChartSpec;
          readonly chartSelection: c.ChartSelection | null;
          readonly colorMappings: c.ChartColorMappings;
          readonly height: number | null;
          readonly resultVariable: string;
          readonly outputResult: boolean;
          readonly displayType: c.ChartDisplayType;
          readonly chartCellId: c.ChartCellId;
          readonly chartDisplayTableConfig: {
            readonly __typename: "DisplayTableConfig";
            readonly id: c.DisplayTableConfigId;
            readonly revision: number;
            readonly pageSize: number;
            readonly height: number | null;
            readonly hideIcons: boolean;
            readonly defaultColumnWidth: number | null;
            readonly hideIndex: boolean;
            readonly sortByColumnDefault: string | null;
            readonly sortByIndexColumnDefault: number | null;
            readonly sortDirectionDefault: Types.SortDirection;
            readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
            readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
            readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
            readonly filters: c.TableFiltersDefinition | null;
            readonly calcs: c.CalcsDefinition | null;
            readonly pinnedColumns: ReadonlyArray<string> | null;
            readonly hiddenColumns: ReadonlyArray<string> | null;
            readonly pinIndexColumns: boolean;
            readonly showAggregations: boolean;
            readonly columnAggregations: c.ColumnAggregationsDefinition | null;
            readonly conditionalFormattingReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly conditionalFormattingReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
            readonly columnProperties: ReadonlyArray<{
              readonly __typename: "ColumnProperties";
              readonly revision: number;
              readonly originalName: c.DisplayTableColumnId;
              readonly displayFormat: c.ColumnDisplayFormat | null;
              readonly renameTo: string | null;
              readonly size: number | null;
              readonly wrapText: boolean | null;
            }>;
            readonly filtersReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly filtersReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
          } | null;
        }
      | {
          readonly __typename: "CodeCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly source: string;
          readonly codeCellId: c.CodeCellId;
          readonly cellReferencesV2: {
            readonly __typename: "PythonCellReferencesV2";
            readonly imports: ReadonlyArray<c.VariableName>;
            readonly importStrings: ReadonlyArray<string>;
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly referencedKeys: ReadonlyArray<c.ParamReferenceKey> | null;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly functions: ReadonlyArray<{
              readonly __typename: "FunctionDefinition";
              readonly name: string;
              readonly src: string;
            }>;
            readonly errors: ReadonlyArray<{
              readonly __typename: "ErrorDefinition";
              readonly errorType: string;
              readonly description: string;
              readonly location: {
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              };
            }>;
          } | null;
          readonly cellReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        }
      | {
          readonly __typename: "CollapsibleCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly labelStyle: Types.CollapsibleCellLabelStyle;
          readonly collapsibleCellId: c.CollapsibleCellId;
        }
      | {
          readonly __typename: "ComponentImportCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly childCellCount: number | null;
          readonly componentVersionId: c.HexVersionId | null;
          readonly componentImportCellId: c.ComponentImportCellId;
          readonly componentVersionStub: {
            readonly __typename: "ComponentVersionStub";
            readonly id: c.HexVersionId;
            readonly orgId: c.OrgId;
            readonly version: c.HexVersionString;
            readonly title: string;
            readonly componentId: c.HexId;
            readonly canView: boolean;
            readonly inTrash: boolean;
          } | null;
        }
      | {
          readonly __typename: "DbtMetricCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly resultVariable: string;
          readonly useRichDisplay: boolean;
          readonly castDecimals: boolean;
          readonly useNativeDates: boolean;
          readonly selectedTimegrain: string | null;
          readonly startDate: c.DateTimeString | null;
          readonly endDate: c.DateTimeString | null;
          readonly selectedDimensions: ReadonlyArray<string> | null;
          readonly secondaryCalculations: ReadonlyArray<c.SecondaryCalculations>;
          readonly connectionId: c.DataConnectionId | null;
          readonly dbtMetricCellId: c.DbtMetricCellId;
          readonly metrics: ReadonlyArray<{
            readonly __typename: "DataSourceDbtMetric";
            readonly id: c.DataSourceDbtMetricId;
          }>;
          readonly dbtMetricDisplayTableConfig: {
            readonly __typename: "DisplayTableConfig";
            readonly id: c.DisplayTableConfigId;
            readonly revision: number;
            readonly pageSize: number;
            readonly height: number | null;
            readonly hideIcons: boolean;
            readonly defaultColumnWidth: number | null;
            readonly hideIndex: boolean;
            readonly sortByColumnDefault: string | null;
            readonly sortByIndexColumnDefault: number | null;
            readonly sortDirectionDefault: Types.SortDirection;
            readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
            readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
            readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
            readonly filters: c.TableFiltersDefinition | null;
            readonly calcs: c.CalcsDefinition | null;
            readonly pinnedColumns: ReadonlyArray<string> | null;
            readonly hiddenColumns: ReadonlyArray<string> | null;
            readonly pinIndexColumns: boolean;
            readonly showAggregations: boolean;
            readonly columnAggregations: c.ColumnAggregationsDefinition | null;
            readonly conditionalFormattingReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly conditionalFormattingReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
            readonly columnProperties: ReadonlyArray<{
              readonly __typename: "ColumnProperties";
              readonly revision: number;
              readonly originalName: c.DisplayTableColumnId;
              readonly displayFormat: c.ColumnDisplayFormat | null;
              readonly renameTo: string | null;
              readonly size: number | null;
              readonly wrapText: boolean | null;
            }>;
            readonly filtersReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly filtersReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
          } | null;
        }
      | {
          readonly __typename: "DisplayTableCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly dataframe: c.NoCodeCellDataframe | null;
          readonly resultVariable: string;
          readonly displayTableCellId: c.DisplayTableCellId;
          readonly displayTableConfig: {
            readonly __typename: "DisplayTableConfig";
            readonly id: c.DisplayTableConfigId;
            readonly revision: number;
            readonly pageSize: number;
            readonly height: number | null;
            readonly hideIcons: boolean;
            readonly defaultColumnWidth: number | null;
            readonly hideIndex: boolean;
            readonly sortByColumnDefault: string | null;
            readonly sortByIndexColumnDefault: number | null;
            readonly sortDirectionDefault: Types.SortDirection;
            readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
            readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
            readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
            readonly filters: c.TableFiltersDefinition | null;
            readonly calcs: c.CalcsDefinition | null;
            readonly pinnedColumns: ReadonlyArray<string> | null;
            readonly hiddenColumns: ReadonlyArray<string> | null;
            readonly pinIndexColumns: boolean;
            readonly showAggregations: boolean;
            readonly columnAggregations: c.ColumnAggregationsDefinition | null;
            readonly conditionalFormattingReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly conditionalFormattingReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
            readonly columnProperties: ReadonlyArray<{
              readonly __typename: "ColumnProperties";
              readonly revision: number;
              readonly originalName: c.DisplayTableColumnId;
              readonly displayFormat: c.ColumnDisplayFormat | null;
              readonly renameTo: string | null;
              readonly size: number | null;
              readonly wrapText: boolean | null;
            }>;
            readonly filtersReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly filtersReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
          };
        }
      | {
          readonly __typename: "ExploreCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly colorMappings: c.ChartColorMappings;
          readonly spec: c.ExploreSpec;
          readonly semanticProjectId: c.SemanticProjectId | null;
          readonly resultVariables: ReadonlyArray<string>;
          readonly resultIncludeDetailColumns: boolean;
          readonly height: number | null;
          readonly exploreCellId: c.ExploreCellId;
          readonly exploreDataframe: c.ExploreCellDataframe | null;
          readonly displayTableConfig: {
            readonly __typename: "DisplayTableConfig";
            readonly id: c.DisplayTableConfigId;
            readonly revision: number;
            readonly pageSize: number;
            readonly height: number | null;
            readonly hideIcons: boolean;
            readonly defaultColumnWidth: number | null;
            readonly hideIndex: boolean;
            readonly sortByColumnDefault: string | null;
            readonly sortByIndexColumnDefault: number | null;
            readonly sortDirectionDefault: Types.SortDirection;
            readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
            readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
            readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
            readonly filters: c.TableFiltersDefinition | null;
            readonly calcs: c.CalcsDefinition | null;
            readonly pinnedColumns: ReadonlyArray<string> | null;
            readonly hiddenColumns: ReadonlyArray<string> | null;
            readonly pinIndexColumns: boolean;
            readonly showAggregations: boolean;
            readonly columnAggregations: c.ColumnAggregationsDefinition | null;
            readonly conditionalFormattingReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly conditionalFormattingReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
            readonly columnProperties: ReadonlyArray<{
              readonly __typename: "ColumnProperties";
              readonly revision: number;
              readonly originalName: c.DisplayTableColumnId;
              readonly displayFormat: c.ColumnDisplayFormat | null;
              readonly renameTo: string | null;
              readonly size: number | null;
              readonly wrapText: boolean | null;
            }>;
            readonly filtersReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly filtersReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
          };
        }
      | {
          readonly __typename: "FilterCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly dataframe: c.NoCodeCellDataframe | null;
          readonly filters: c.FilterGroup | null;
          readonly resultVariable: string;
          readonly filterType: Types.FilterType;
          readonly appMode: Types.FilterCellAppMode;
          readonly castDecimals: boolean;
          readonly useQueryMode: boolean;
          readonly useNativeDates: boolean;
          readonly cellOutputType: Types.CellOutputType | null;
          readonly filterCellId: c.FilterCellId;
          readonly filtersReferences: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly filtersReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        }
      | {
          readonly __typename: "MapCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly map: c.Map;
          readonly height: number | null;
          readonly mapCellId: c.MapCellId;
        }
      | {
          readonly __typename: "MarkdownCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly source: string;
          readonly markdownCellId: c.MarkdownCellId;
          readonly cellReferencesV2: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly cellReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        }
      | {
          readonly __typename: "MetricCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly title: string | null;
          readonly valueVariableName: string | null;
          readonly displayFormat: c.MetricDisplayFormat | null;
          readonly showComparison: boolean;
          readonly comparisonType: Types.MetricCellComparisonType | null;
          readonly comparisonVariableName: string | null;
          readonly comparisonAggregate: c.MetricCellAggregate | null;
          readonly comparisonFormat: Types.MetricCellComparisonFormat | null;
          readonly comparisonLabel: string | null;
          readonly valueColumn: string | null;
          readonly valueRowIndex: number | null;
          readonly valueAggregate: c.MetricCellAggregate | null;
          readonly comparisonColumn: string | null;
          readonly comparisonRowIndex: number | null;
          readonly outputResult: boolean;
          readonly valueResultVariable: string | null;
          readonly comparisonResultVariable: string | null;
          readonly metricCellId: c.MetricCellId;
          readonly cellReferencesV2: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly cellReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        }
      | {
          readonly __typename: "Parameter";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly name: c.ParameterName;
          readonly outputType: Types.ParameterOutputType;
          readonly inputType: Types.ParameterInputType;
          readonly options: c.ParameterOptions | null;
          readonly defaultValueString: c.JsonSerializedParameterValueContents;
          readonly required: boolean;
          readonly inputCellId: c.ParameterId;
        }
      | {
          readonly __typename: "PivotCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly dataframe: c.NoCodeCellDataframe | null;
          readonly resultVariable: string;
          readonly pivotConfig: c.PivotTableConfig;
          readonly castDecimals: boolean;
          readonly pivotCellId: c.PivotCellId;
          readonly displayTableConfig: {
            readonly __typename: "DisplayTableConfig";
            readonly id: c.DisplayTableConfigId;
            readonly revision: number;
            readonly pageSize: number;
            readonly height: number | null;
            readonly hideIcons: boolean;
            readonly defaultColumnWidth: number | null;
            readonly hideIndex: boolean;
            readonly sortByColumnDefault: string | null;
            readonly sortByIndexColumnDefault: number | null;
            readonly sortDirectionDefault: Types.SortDirection;
            readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
            readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
            readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
            readonly filters: c.TableFiltersDefinition | null;
            readonly calcs: c.CalcsDefinition | null;
            readonly pinnedColumns: ReadonlyArray<string> | null;
            readonly hiddenColumns: ReadonlyArray<string> | null;
            readonly pinIndexColumns: boolean;
            readonly showAggregations: boolean;
            readonly columnAggregations: c.ColumnAggregationsDefinition | null;
            readonly conditionalFormattingReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly conditionalFormattingReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
            readonly columnProperties: ReadonlyArray<{
              readonly __typename: "ColumnProperties";
              readonly revision: number;
              readonly originalName: c.DisplayTableColumnId;
              readonly displayFormat: c.ColumnDisplayFormat | null;
              readonly renameTo: string | null;
              readonly size: number | null;
              readonly wrapText: boolean | null;
            }>;
            readonly filtersReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly filtersReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
          };
        }
      | {
          readonly __typename: "SqlCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly source: string;
          readonly resultVariable: string;
          readonly useRichDisplay: boolean;
          readonly enablePreview: boolean;
          readonly castDecimals: boolean;
          readonly useNativeDates: boolean;
          readonly loadIntoDataFrame: boolean;
          readonly dataFrameCell: boolean;
          readonly allowDuplicateColumns: boolean;
          readonly sqlCellOutputType: Types.CellOutputType;
          readonly sqlCellReferencesV3: c.StoredSqlReferencesV3 | null;
          readonly jinjaCellReferencesV3: c.StoredCellReferencesV3 | null;
          readonly jinjaSqlReferences: c.StoredJinjaSqlReferences | null;
          readonly connectionId: c.DataConnectionId | null;
          readonly sqlCellId: c.SqlCellId;
          readonly sqlDisplayTableConfig: {
            readonly __typename: "DisplayTableConfig";
            readonly id: c.DisplayTableConfigId;
            readonly revision: number;
            readonly pageSize: number;
            readonly height: number | null;
            readonly hideIcons: boolean;
            readonly defaultColumnWidth: number | null;
            readonly hideIndex: boolean;
            readonly sortByColumnDefault: string | null;
            readonly sortByIndexColumnDefault: number | null;
            readonly sortDirectionDefault: Types.SortDirection;
            readonly customColumnOrdering: ReadonlyArray<c.DisplayTableColumnId> | null;
            readonly pivotColumnOrdering: ReadonlyArray<Types.SortDirection | null> | null;
            readonly conditionalFormatting: c.ConditionalFormattingDefinition | null;
            readonly filters: c.TableFiltersDefinition | null;
            readonly calcs: c.CalcsDefinition | null;
            readonly pinnedColumns: ReadonlyArray<string> | null;
            readonly hiddenColumns: ReadonlyArray<string> | null;
            readonly pinIndexColumns: boolean;
            readonly showAggregations: boolean;
            readonly columnAggregations: c.ColumnAggregationsDefinition | null;
            readonly conditionalFormattingReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly conditionalFormattingReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
            readonly columnProperties: ReadonlyArray<{
              readonly __typename: "ColumnProperties";
              readonly revision: number;
              readonly originalName: c.DisplayTableColumnId;
              readonly displayFormat: c.ColumnDisplayFormat | null;
              readonly renameTo: string | null;
              readonly size: number | null;
              readonly wrapText: boolean | null;
            }>;
            readonly filtersReferences: {
              readonly __typename: "CellReferencesV2";
              readonly newParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
              readonly referencedParams: ReadonlyArray<{
                readonly __typename: "ParamReference";
                readonly param: c.VariableName;
                readonly locations: ReadonlyArray<{
                  readonly __typename: "SourceLocation";
                  readonly line: number;
                  readonly column: number;
                }>;
              }>;
            } | null;
            readonly filtersReferencesParseError: {
              readonly __typename: "CellReferencesParseError";
              readonly error: string;
            } | null;
          } | null;
          readonly cellReferencesV2: {
            readonly __typename: "SqlCellReferencesV2";
            readonly containsBlocks: boolean;
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly cellReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        }
      | {
          readonly __typename: "TextCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly richText: c.RichTextDocument;
          readonly textCellId: c.TextCellId;
          readonly cellReferencesV2: {
            readonly __typename: "CellReferencesV2";
            readonly newParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
            readonly referencedParams: ReadonlyArray<{
              readonly __typename: "ParamReference";
              readonly param: c.VariableName;
              readonly locations: ReadonlyArray<{
                readonly __typename: "SourceLocation";
                readonly line: number;
                readonly column: number;
              }>;
            }>;
          } | null;
          readonly cellReferencesParseError: {
            readonly __typename: "CellReferencesParseError";
            readonly error: string;
          } | null;
        }
      | {
          readonly __typename: "VegaChartCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly vegaSpec: c.VegaLiteSpec | null;
          readonly metadata: c.VegaMetadata | null;
          readonly selectedLayerIndex: number;
          readonly height: number | null;
          readonly defaultInputTimezone: c.TimezoneName | null;
          readonly vegaChartCellId: c.VegaChartCellId;
        }
      | {
          readonly __typename: "WritebackCell";
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly databaseName: string | null;
          readonly schemaName: string | null;
          readonly tableName: string | null;
          readonly dynamicTableName: boolean;
          readonly dataframeName: string | null;
          readonly runOnScheduledRun: boolean;
          readonly runInLogicView: boolean;
          readonly runInApp: boolean;
          readonly overwrite: boolean;
          readonly connectionId: c.DataConnectionId | null;
          readonly writebackCellId: c.WritebackCellId;
        };
    readonly latestMagicEvent: {
      readonly __typename: "MagicEvent";
      readonly id: c.MagicEventId;
      readonly cellId: c.CellId | null;
      readonly agentChatThreadId: c.AgentChatThreadId | null;
      readonly accepted: boolean | null;
      readonly createdDate: c.DateTimeString;
      readonly dataConnectionId: c.DataConnectionId | null;
      readonly eventSource: Types.MagicEventSource | null;
      readonly eventType: Types.MagicKeyword;
      readonly result: string | null;
      readonly status: Types.MagicEventStatus | null;
      readonly userProvidedPrompt: string | null;
      readonly richTextPrompt: c.RichTextDocument | null;
      readonly userId: c.UserId;
      readonly parentEventId: c.MagicEventId | null;
      readonly unsupportedResponse: boolean;
      readonly revision: number;
      readonly nextEventId: c.MagicEventId | null;
      readonly prevEventId: c.MagicEventId | null;
      readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
      readonly requestMode: Types.MagicRequestMode | null;
      readonly cellRunResult: Types.MagicCellRunResult | null;
      readonly userFacingResult: string | null;
      readonly acceptType: Types.MagicAcceptType | null;
      readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
      readonly failureReason: Types.MagicEventFailureReason | null;
      readonly autoTriggered: boolean | null;
      readonly duration: number | null;
      readonly timeToFirstToken: number | null;
      readonly cellPayload: c.MagicCellPayload | null;
      readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
      readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
      readonly summary: string | null;
      readonly cancelled: boolean;
      readonly intent: Types.ExploreIntent | null;
      readonly childEvents: ReadonlyArray<{
        readonly __typename: "MagicEvent";
        readonly id: c.MagicEventId;
        readonly cellId: c.CellId | null;
        readonly agentChatThreadId: c.AgentChatThreadId | null;
        readonly accepted: boolean | null;
        readonly createdDate: c.DateTimeString;
        readonly dataConnectionId: c.DataConnectionId | null;
        readonly eventSource: Types.MagicEventSource | null;
        readonly eventType: Types.MagicKeyword;
        readonly result: string | null;
        readonly status: Types.MagicEventStatus | null;
        readonly userProvidedPrompt: string | null;
        readonly richTextPrompt: c.RichTextDocument | null;
        readonly userId: c.UserId;
        readonly parentEventId: c.MagicEventId | null;
        readonly unsupportedResponse: boolean;
        readonly revision: number;
        readonly nextEventId: c.MagicEventId | null;
        readonly prevEventId: c.MagicEventId | null;
        readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
        readonly requestMode: Types.MagicRequestMode | null;
        readonly cellRunResult: Types.MagicCellRunResult | null;
        readonly userFacingResult: string | null;
        readonly acceptType: Types.MagicAcceptType | null;
        readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
        readonly failureReason: Types.MagicEventFailureReason | null;
        readonly autoTriggered: boolean | null;
        readonly duration: number | null;
        readonly timeToFirstToken: number | null;
        readonly cellPayload: c.MagicCellPayload | null;
        readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
        readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
        readonly summary: string | null;
        readonly cancelled: boolean;
        readonly intent: Types.ExploreIntent | null;
      }>;
    } | null;
  }>;
  readonly canvasLayout: {
    readonly __typename: "CanvasLayout";
    readonly id: c.CanvasLayoutId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly name: string | null;
    readonly height: number;
    readonly width: number;
    readonly canvasElements: ReadonlyArray<{
      readonly __typename: "CanvasElement";
      readonly id: c.CanvasElementId;
      readonly createdDate: c.DateTimeString;
      readonly updatedDate: c.DateTimeString;
      readonly deletedDate: c.DateTimeString | null;
      readonly revision: number;
      readonly width: number;
      readonly height: number;
      readonly x: number;
      readonly y: number;
      readonly z: number;
      readonly showLabel: boolean;
      readonly cellId: c.CellId;
    }>;
  };
  readonly gridLayouts: ReadonlyArray<{
    readonly __typename: "GridLayout";
    readonly id: c.GridLayoutId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly order: string;
    readonly name: string;
    readonly staticId: c.StaticGridLayoutId | null;
    readonly gridRows: ReadonlyArray<{
      readonly __typename: "GridRow";
      readonly id: c.GridRowId;
      readonly createdDate: c.DateTimeString;
      readonly updatedDate: c.DateTimeString;
      readonly deletedDate: c.DateTimeString | null;
      readonly revision: number;
      readonly order: string;
      readonly gridLayoutId: c.GridLayoutId;
      readonly gridColumns: ReadonlyArray<{
        readonly __typename: "GridColumn";
        readonly id: c.GridColumnId;
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly start: number;
        readonly end: number;
        readonly gridElements: ReadonlyArray<{
          readonly __typename: "GridElement";
          readonly id: c.GridElementId;
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly height: number | null;
          readonly explorable: boolean | null;
          readonly showLabel: boolean;
          readonly showSource: boolean;
          readonly hideOutput: boolean;
          readonly type: Types.GridElementType;
          readonly entityId: c.GridElementEntityId;
        }>;
      }>;
    }>;
  }>;
  readonly storyLayout: {
    readonly __typename: "StoryLayout";
    readonly id: c.StoryLayoutId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly storyElements: ReadonlyArray<{
      readonly __typename: "StoryElement";
      readonly id: c.StoryElementId;
      readonly createdDate: c.DateTimeString;
      readonly updatedDate: c.DateTimeString;
      readonly deletedDate: c.DateTimeString | null;
      readonly revision: number;
      readonly visible: boolean;
      readonly showLabel: boolean;
      readonly cell: {
        readonly __typename: "Cell";
        readonly id: c.CellId;
      } | null;
    }>;
  };
  readonly files: ReadonlyArray<{
    readonly __typename: "File";
    readonly id: c.FileId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly filename: string;
    readonly size: string;
    readonly uploadState: Types.FileUploadState;
    readonly inputCellId: c.ParameterId | null;
  }>;
  readonly secrets: ReadonlyArray<{
    readonly __typename: "Secret";
    readonly id: c.SecretId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly name: c.SecretName;
  }>;
  readonly hexVersionSecrets: ReadonlyArray<{
    readonly __typename: "HexVersionSecret";
    readonly id: c.HexVersionSecretId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly secretId: c.SecretId;
  }>;
  readonly magicEvents: ReadonlyArray<{
    readonly __typename: "MagicEvent";
    readonly id: c.MagicEventId;
    readonly cellId: c.CellId | null;
    readonly agentChatThreadId: c.AgentChatThreadId | null;
    readonly accepted: boolean | null;
    readonly createdDate: c.DateTimeString;
    readonly dataConnectionId: c.DataConnectionId | null;
    readonly eventSource: Types.MagicEventSource | null;
    readonly eventType: Types.MagicKeyword;
    readonly result: string | null;
    readonly status: Types.MagicEventStatus | null;
    readonly userProvidedPrompt: string | null;
    readonly richTextPrompt: c.RichTextDocument | null;
    readonly userId: c.UserId;
    readonly parentEventId: c.MagicEventId | null;
    readonly unsupportedResponse: boolean;
    readonly revision: number;
    readonly nextEventId: c.MagicEventId | null;
    readonly prevEventId: c.MagicEventId | null;
    readonly chainTemplateType: Types.MagicCellChainTemplateType | null;
    readonly requestMode: Types.MagicRequestMode | null;
    readonly cellRunResult: Types.MagicCellRunResult | null;
    readonly userFacingResult: string | null;
    readonly acceptType: Types.MagicAcceptType | null;
    readonly mentionedDataframes: ReadonlyArray<c.MentionedDataframeName> | null;
    readonly failureReason: Types.MagicEventFailureReason | null;
    readonly autoTriggered: boolean | null;
    readonly duration: number | null;
    readonly timeToFirstToken: number | null;
    readonly cellPayload: c.MagicCellPayload | null;
    readonly relatedProjectIds: ReadonlyArray<c.HexId> | null;
    readonly topReferenceInfo: ReadonlyArray<c.MagicClientReferenceInfo> | null;
    readonly summary: string | null;
    readonly cancelled: boolean;
    readonly intent: Types.ExploreIntent | null;
  }>;
  readonly dataConnectionHexVersionLinks: ReadonlyArray<{
    readonly __typename: "DataConnectionHexVersionLink";
    readonly id: c.DataConnectionHexVersionLinkId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly dataConnectionId: c.DataConnectionId;
    readonly dataConnectionLinkType: Types.DataConnectionLinkType;
  }>;
  readonly fileHexVersionLinks: ReadonlyArray<{
    readonly __typename: "FileHexVersionLink";
    readonly id: c.FileHexVersionLinkId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly fileId: c.FileId;
  }>;
  readonly vcsPackageHexVersionLinks: ReadonlyArray<{
    readonly __typename: "VcsPackageHexVersionLink";
    readonly id: c.VcsPackageHexVersionLinkId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly vcsPackageId: c.VcsPackageId;
  }>;
  readonly syncRepositoryHexVersionLinks: ReadonlyArray<{
    readonly __typename: "SyncRepositoryHexVersionLink";
    readonly id: c.SyncRepositoryHexVersionLinkId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly syncRepositoryId: c.SyncRepositoryId;
    readonly filePath: string | null;
    readonly branch: string;
  }>;
  readonly externalFileIntegrationHexVersionLinks: ReadonlyArray<{
    readonly __typename: "ExternalFileIntegrationHexVersionLink";
    readonly id: c.ExternalFileIntegrationHexVersionLinkId;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
    readonly revision: number;
    readonly externalFileIntegrationId: c.ExternalFileIntegrationId;
    readonly files: ReadonlyArray<string> | null;
  }>;
  readonly oAuthSettings: {
    readonly __typename: "HexVersionOAuthSettings";
    readonly id: c.HexVersionOAuthSettingsId;
    readonly logicViewTokenShared: boolean;
    readonly publishedAppTokenShared: boolean;
    readonly publishedAppTokenSharingAllowed: boolean;
    readonly canEdit: boolean;
  } | null;
  readonly explore: {
    readonly __typename: "Explore";
    readonly id: c.ExploreId;
    readonly primaryCellStaticId: c.StaticCellId;
    readonly exploreFromCellStaticId: c.StaticCellId | null;
    readonly saved: boolean;
    readonly revision: number;
    readonly isSourceHexDeleted: boolean;
    readonly isSourceCellDeleted: boolean;
    readonly exploredFromCell: {
      readonly __typename: "Cell";
      readonly id: c.CellId;
      readonly label: string | null;
    } | null;
    readonly sourceHexVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly hex: {
        readonly __typename: "Hex";
        readonly id: c.HexId;
        readonly title: string;
        readonly archivedDate: c.DateTimeString | null;
        readonly trashDate: c.DateTimeString | null;
        readonly hexType: Types.HexType;
      };
    } | null;
  } | null;
  readonly sharedFilters: ReadonlyArray<{
    readonly __typename: "SharedFilter";
    readonly id: c.SharedFilterId;
    readonly name: string;
    readonly type: Types.SharedFilterInputType;
    readonly operator: Types.SharedFilterPredicateOp | null;
    readonly options: c.ParameterOptions | null;
    readonly autoLinks: c.SharedFilterAutoLinks;
    readonly manualLinks: c.SharedFilterManualLinks;
    readonly defaultValue: c.JsonSerializedParameterValueContents | null;
    readonly revision: number;
    readonly createdDate: c.DateTimeString;
    readonly updatedDate: c.DateTimeString;
    readonly deletedDate: c.DateTimeString | null;
  }>;
};

export const CodeCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment CodeCellMPFragment on CodeCell {
    codeCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    source
    cellReferencesV2 {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
        referencedKeys
      }
      imports
      importStrings
      functions {
        name
        src
      }
      errors {
        errorType
        description
        location {
          line
          column
        }
      }
    }
    cellReferencesParseError {
      error
    }
  }
`;
export const MarkdownCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment MarkdownCellMPFragment on MarkdownCell {
    markdownCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    source
    cellReferencesV2 {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
    }
    cellReferencesParseError {
      error
    }
  }
`;
export const DisplayTableConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment DisplayTableConfigFragment on DisplayTableConfig {
    id
    revision
    pageSize
    height
    hideIcons
    defaultColumnWidth
    hideIndex
    sortByColumnDefault
    sortByIndexColumnDefault
    sortDirectionDefault
    customColumnOrdering
    pivotColumnOrdering
    conditionalFormatting
    conditionalFormattingReferences {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
    }
    conditionalFormattingReferencesParseError {
      error
    }
    columnProperties {
      revision
      originalName
      displayFormat
      renameTo
      size
      wrapText
    }
    filters
    filtersReferences {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
    }
    filtersReferencesParseError {
      error
    }
    calcs
    pinnedColumns
    hiddenColumns
    pinIndexColumns
    showAggregations
    columnAggregations
  }
`;
export const DisplayTableCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment DisplayTableCellMPFragment on DisplayTableCell {
    displayTableCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    dataframe
    resultVariable
    displayTableConfig {
      ...DisplayTableConfigFragment
    }
  }
  ${DisplayTableConfigFragmentDoc}
`;
export const InputCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment InputCellMPFragment on Parameter {
    inputCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    name
    outputType
    inputType
    options
    defaultValueString
    required
  }
`;
export const SqlCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment SqlCellMPFragment on SqlCell {
    sqlCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    source
    resultVariable
    useRichDisplay
    enablePreview
    castDecimals
    useNativeDates
    loadIntoDataFrame
    dataFrameCell
    allowDuplicateColumns
    sqlCellOutputType
    sqlDisplayTableConfig: displayTableConfig {
      ...DisplayTableConfigFragment
    }
    cellReferencesV2 {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
      containsBlocks
    }
    sqlCellReferencesV3
    jinjaCellReferencesV3
    jinjaSqlReferences
    cellReferencesParseError {
      error
    }
    connectionId
  }
  ${DisplayTableConfigFragmentDoc}
`;
export const VegaChartCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment VegaChartCellMPFragment on VegaChartCell {
    vegaChartCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    vegaSpec
    metadata
    selectedLayerIndex
    height
    defaultInputTimezone
  }
`;
export const MetricCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment MetricCellMPFragment on MetricCell {
    metricCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    title
    valueVariableName
    displayFormat
    showComparison
    comparisonType
    comparisonVariableName
    comparisonAggregate
    comparisonFormat
    comparisonLabel
    cellReferencesV2 {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
    }
    cellReferencesParseError {
      error
    }
    valueColumn
    valueRowIndex
    valueAggregate
    comparisonColumn
    comparisonRowIndex
    outputResult
    valueResultVariable
    comparisonResultVariable
  }
`;
export const TextCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment TextCellMPFragment on TextCell {
    textCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    richText
    cellReferencesV2 {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
    }
    cellReferencesParseError {
      error
    }
  }
`;
export const MapCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment MapCellMPFragment on MapCell {
    mapCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    map
    height
  }
`;
export const WritebackCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment WritebackCellMPFragment on WritebackCell {
    writebackCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    databaseName
    schemaName
    tableName
    dynamicTableName
    dataframeName
    runOnScheduledRun
    runInLogicView
    runInApp
    overwrite
    connectionId
  }
`;
export const DbtMetricCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment DbtMetricCellMPFragment on DbtMetricCell {
    dbtMetricCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    resultVariable
    useRichDisplay
    castDecimals
    useNativeDates
    metrics {
      id
    }
    selectedTimegrain
    startDate
    endDate
    selectedDimensions
    dbtMetricDisplayTableConfig: displayTableConfig {
      ...DisplayTableConfigFragment
    }
    secondaryCalculations
    connectionId
  }
  ${DisplayTableConfigFragmentDoc}
`;
export const PivotCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment PivotCellMPFragment on PivotCell {
    pivotCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    dataframe
    resultVariable
    pivotConfig
    castDecimals
    displayTableConfig {
      ...DisplayTableConfigFragment
    }
  }
  ${DisplayTableConfigFragmentDoc}
`;
export const FilterCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment FilterCellMPFragment on FilterCell {
    filterCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    dataframe
    filters
    resultVariable
    filterType
    appMode
    castDecimals
    useQueryMode
    useNativeDates
    cellOutputType
    filtersReferences {
      newParams {
        param
        locations {
          line
          column
        }
      }
      referencedParams {
        param
        locations {
          line
          column
        }
      }
    }
    filtersReferencesParseError {
      error
    }
  }
`;
export const ComponentImportCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment ComponentImportCellMPFragment on ComponentImportCell {
    componentImportCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    childCellCount
    componentVersionId
    componentVersionStub {
      id
      orgId
      version
      title
      componentId
      canView
      inTrash
    }
  }
`;
export const ChartCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment ChartCellMPFragment on ChartCell {
    chartCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    chartSpec
    chartSelection
    colorMappings
    height
    resultVariable
    outputResult
    displayType
    chartDisplayTableConfig: displayTableConfig {
      ...DisplayTableConfigFragment
    }
  }
  ${DisplayTableConfigFragmentDoc}
`;
export const BlockCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment BlockCellMPFragment on BlockCell {
    blockCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    blockConfig
  }
`;
export const ExploreCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment ExploreCellMPFragment on ExploreCell {
    exploreCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    exploreDataframe: dataframe
    colorMappings
    spec
    semanticProjectId
    resultVariables
    resultIncludeDetailColumns
    height
    displayTableConfig {
      ...DisplayTableConfigFragment
    }
  }
  ${DisplayTableConfigFragmentDoc}
`;
export const CollapsibleCellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment CollapsibleCellMPFragment on CollapsibleCell {
    collapsibleCellId: id
    createdDate
    updatedDate
    deletedDate
    revision
    labelStyle
  }
`;
export const CellContentsMpFragmentDoc = /*#__PURE__*/ gql`
  fragment CellContentsMPFragment on CellContents {
    ...CodeCellMPFragment
    ...MarkdownCellMPFragment
    ...DisplayTableCellMPFragment
    ...InputCellMPFragment
    ...SqlCellMPFragment
    ...VegaChartCellMPFragment
    ...MetricCellMPFragment
    ...TextCellMPFragment
    ...MapCellMPFragment
    ...WritebackCellMPFragment
    ...DbtMetricCellMPFragment
    ...PivotCellMPFragment
    ...FilterCellMPFragment
    ...ComponentImportCellMPFragment
    ...ChartCellMPFragment
    ...BlockCellMPFragment
    ...ExploreCellMPFragment
    ...CollapsibleCellMPFragment
  }
  ${CodeCellMpFragmentDoc}
  ${MarkdownCellMpFragmentDoc}
  ${DisplayTableCellMpFragmentDoc}
  ${InputCellMpFragmentDoc}
  ${SqlCellMpFragmentDoc}
  ${VegaChartCellMpFragmentDoc}
  ${MetricCellMpFragmentDoc}
  ${TextCellMpFragmentDoc}
  ${MapCellMpFragmentDoc}
  ${WritebackCellMpFragmentDoc}
  ${DbtMetricCellMpFragmentDoc}
  ${PivotCellMpFragmentDoc}
  ${FilterCellMpFragmentDoc}
  ${ComponentImportCellMpFragmentDoc}
  ${ChartCellMpFragmentDoc}
  ${BlockCellMpFragmentDoc}
  ${ExploreCellMpFragmentDoc}
  ${CollapsibleCellMpFragmentDoc}
`;
export const MagicEventFragmentDoc = /*#__PURE__*/ gql`
  fragment MagicEventFragment on MagicEvent {
    id
    cellId
    agentChatThreadId
    accepted
    createdDate
    dataConnectionId
    eventSource
    eventType
    result
    status
    userProvidedPrompt
    richTextPrompt
    userId
    parentEventId
    unsupportedResponse
    revision
    nextEventId
    prevEventId
    chainTemplateType
    requestMode
    cellRunResult
    userFacingResult
    acceptType
    mentionedDataframes
    failureReason
    autoTriggered
    duration
    timeToFirstToken
    cellPayload
    relatedProjectIds
    topReferenceInfo
    summary
    cancelled
    intent
  }
`;
export const MagicEventAndChildrenFragmentDoc = /*#__PURE__*/ gql`
  fragment MagicEventAndChildrenFragment on MagicEvent {
    ...MagicEventFragment
    childEvents {
      ...MagicEventFragment
    }
  }
  ${MagicEventFragmentDoc}
`;
export const CellMpFragmentDoc = /*#__PURE__*/ gql`
  fragment CellMPFragment on Cell {
    id
    staticId
    createdDate
    updatedDate
    deletedDate
    revision
    order
    label
    sourceRevision
    cellType
    cellContents {
      ...CellContentsMPFragment
    }
    parentComponentImportCellId
    staticCellIdInSourceComponent
    componentImportCellId
    parentBlockCellId
    blockCellId
    latestMagicEventId
    parentCellId
    latestMagicEvent {
      ...MagicEventAndChildrenFragment
    }
  }
  ${CellContentsMpFragmentDoc}
  ${MagicEventAndChildrenFragmentDoc}
`;
export const CanvasElementMpFragmentDoc = /*#__PURE__*/ gql`
  fragment CanvasElementMPFragment on CanvasElement {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    width
    height
    x
    y
    z
    showLabel
    cellId
  }
`;
export const CanvasLayoutMpFragmentDoc = /*#__PURE__*/ gql`
  fragment CanvasLayoutMPFragment on CanvasLayout {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    name
    height
    width
    canvasElements {
      ...CanvasElementMPFragment
    }
  }
  ${CanvasElementMpFragmentDoc}
`;
export const GridElementMpFragmentDoc = /*#__PURE__*/ gql`
  fragment GridElementMPFragment on GridElement {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    height
    explorable
    showLabel
    showSource
    hideOutput
    type
    entityId
  }
`;
export const GridColumnMpFragmentDoc = /*#__PURE__*/ gql`
  fragment GridColumnMPFragment on GridColumn {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    start
    end
    gridElements {
      ...GridElementMPFragment
    }
  }
  ${GridElementMpFragmentDoc}
`;
export const GridRowMpFragmentDoc = /*#__PURE__*/ gql`
  fragment GridRowMPFragment on GridRow {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    order
    gridLayoutId
    gridColumns {
      ...GridColumnMPFragment
    }
  }
  ${GridColumnMpFragmentDoc}
`;
export const GridLayoutMpFragmentDoc = /*#__PURE__*/ gql`
  fragment GridLayoutMPFragment on GridLayout {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    gridRows {
      ...GridRowMPFragment
    }
    order
    name
    staticId
  }
  ${GridRowMpFragmentDoc}
`;
export const StoryElementMpFragmentDoc = /*#__PURE__*/ gql`
  fragment StoryElementMPFragment on StoryElement {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    visible
    showLabel
    cell {
      id
    }
  }
`;
export const StoryLayoutMpFragmentDoc = /*#__PURE__*/ gql`
  fragment StoryLayoutMPFragment on StoryLayout {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    storyElements {
      ...StoryElementMPFragment
    }
  }
  ${StoryElementMpFragmentDoc}
`;
export const FileMpFragmentDoc = /*#__PURE__*/ gql`
  fragment FileMPFragment on File {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    filename
    size
    uploadState
    inputCellId
  }
`;
export const SecretMpFragmentDoc = /*#__PURE__*/ gql`
  fragment SecretMPFragment on Secret {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    name
  }
`;
export const HexVersionSecretMpFragmentDoc = /*#__PURE__*/ gql`
  fragment HexVersionSecretMPFragment on HexVersionSecret {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    secretId
  }
`;
export const DataConnectionHexVersionLinkMpFragmentDoc = /*#__PURE__*/ gql`
  fragment DataConnectionHexVersionLinkMPFragment on DataConnectionHexVersionLink {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    dataConnectionId
    dataConnectionLinkType
  }
`;
export const FileHexVersionLinkMpFragmentDoc = /*#__PURE__*/ gql`
  fragment FileHexVersionLinkMPFragment on FileHexVersionLink {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    fileId
  }
`;
export const VcsPackageHexVersionLinkMpFragmentDoc = /*#__PURE__*/ gql`
  fragment VcsPackageHexVersionLinkMPFragment on VcsPackageHexVersionLink {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    vcsPackageId
  }
`;
export const SyncRepositoryHexVersionLinkMpFragmentDoc = /*#__PURE__*/ gql`
  fragment SyncRepositoryHexVersionLinkMPFragment on SyncRepositoryHexVersionLink {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    syncRepositoryId
    filePath
    branch
  }
`;
export const ExternalFileIntegrationHexVersionLinkMpFragmentDoc = /*#__PURE__*/ gql`
  fragment ExternalFileIntegrationHexVersionLinkMPFragment on ExternalFileIntegrationHexVersionLink {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    externalFileIntegrationId
    files
  }
`;
export const ExploreMpFragmentDoc = /*#__PURE__*/ gql`
  fragment ExploreMPFragment on Explore {
    id
    primaryCellStaticId
    exploreFromCellStaticId
    exploredFromCell {
      id
      label
    }
    saved
    revision
    sourceHexVersion {
      id
      hex {
        id
        title
        archivedDate
        trashDate
        hexType
      }
    }
    isSourceHexDeleted
    isSourceCellDeleted
  }
`;
export const SharedFilterMpFragmentDoc = /*#__PURE__*/ gql`
  fragment SharedFilterMPFragment on SharedFilter {
    id
    name
    type
    operator
    options
    autoLinks
    manualLinks
    defaultValue
    revision
    createdDate
    updatedDate
    deletedDate
  }
`;
export const HexVersionMpFragmentDoc = /*#__PURE__*/ gql`
  fragment HexVersionMPFragment on HexVersion {
    id
    createdDate
    updatedDate
    deletedDate
    revision
    date
    name
    displayName
    importPreview
    preview
    description
    version
    published
    layoutType
    castDecimalsDefault
    prerunApp
    logicSessionId
    defaultAppSessionId
    appTheme
    customPublishedAppThemeId
    graphV3
    kernelSize
    kernelImage
    kernelLogicIdleTimeoutMs
    timezone
    visibleMetadataFields
    gridAppMaxWidth
    publishedSnapshotId
    allowExecutionReordering
    canEdit
    editorUserAttributesOverride
    referencedUserAttributes
    minervaDisabledAtEpoch
    semanticProjectMapping
    activeColorPalette {
      id
      name
      colors
    }
    agentChatThreadId
    cells {
      ...CellMPFragment
    }
    canvasLayout {
      ...CanvasLayoutMPFragment
    }
    gridLayouts {
      ...GridLayoutMPFragment
    }
    storyLayout {
      ...StoryLayoutMPFragment
    }
    files {
      ...FileMPFragment
    }
    secrets {
      ...SecretMPFragment
    }
    hexVersionSecrets {
      ...HexVersionSecretMPFragment
    }
    magicEvents {
      ...MagicEventFragment
    }
    dataConnectionHexVersionLinks {
      ...DataConnectionHexVersionLinkMPFragment
    }
    fileHexVersionLinks {
      ...FileHexVersionLinkMPFragment
    }
    vcsPackageHexVersionLinks {
      ...VcsPackageHexVersionLinkMPFragment
    }
    syncRepositoryHexVersionLinks {
      ...SyncRepositoryHexVersionLinkMPFragment
    }
    externalFileIntegrationHexVersionLinks {
      ...ExternalFileIntegrationHexVersionLinkMPFragment
    }
    oAuthSettings {
      ...HexVersionOAuthSettingsFragment
    }
    explore {
      ...ExploreMPFragment
    }
    sharedFilters {
      ...SharedFilterMPFragment
    }
  }
  ${CellMpFragmentDoc}
  ${CanvasLayoutMpFragmentDoc}
  ${GridLayoutMpFragmentDoc}
  ${StoryLayoutMpFragmentDoc}
  ${FileMpFragmentDoc}
  ${SecretMpFragmentDoc}
  ${HexVersionSecretMpFragmentDoc}
  ${MagicEventFragmentDoc}
  ${DataConnectionHexVersionLinkMpFragmentDoc}
  ${FileHexVersionLinkMpFragmentDoc}
  ${VcsPackageHexVersionLinkMpFragmentDoc}
  ${SyncRepositoryHexVersionLinkMpFragmentDoc}
  ${ExternalFileIntegrationHexVersionLinkMpFragmentDoc}
  ${HexVersionOAuthSettingsFragmentDoc}
  ${ExploreMpFragmentDoc}
  ${SharedFilterMpFragmentDoc}
`;
